/* eslint-disable */
// @generated by protobuf-ts 2.9.3 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_number
// @generated from protobuf file "resourcedata.proto" (package "prilus", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message prilus.ResourceData
 */
export interface ResourceData {
    /**
     * @generated from protobuf field: repeated prilus.AchievementInfo AchievementList = 26 [json_name = "AchievementList"];
     */
    AchievementList: AchievementInfo[];
    /**
     * @generated from protobuf field: map<uint32, string> AchievementCategoryNameMap = 27 [json_name = "AchievementCategoryNameMap"];
     */
    AchievementCategoryNameMap: {
        [key: number]: string;
    };
    /**
     * @generated from protobuf field: repeated prilus.BarterInfo BarterList = 1 [json_name = "BarterList"];
     */
    BarterList: BarterInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharCondInfo CharCondList = 28 [json_name = "CharCondList"];
     */
    CharCondList: CharCondInfo[];
    /**
     * @generated from protobuf field: optional prilus.CharStyleData CharStyle = 2 [json_name = "CharStyle"];
     */
    CharStyle?: CharStyleData;
    /**
     * @generated from protobuf field: map<uint32, string> CommercePostNameMap = 3 [json_name = "CommercePostNameMap"];
     */
    CommercePostNameMap: {
        [key: number]: string;
    };
    /**
     * @generated from protobuf field: optional prilus.EquipColData EquipCol = 4 [json_name = "EquipCol"];
     */
    EquipCol?: EquipColData;
    /**
     * @generated from protobuf field: optional prilus.EquipItemData EquipItem = 5 [json_name = "EquipItem"];
     */
    EquipItem?: EquipItemData;
    /**
     * @generated from protobuf field: repeated prilus.FoodInfo FoodList = 6 [json_name = "FoodList"];
     */
    FoodList: FoodInfo[];
    /**
     * @generated from protobuf field: repeated prilus.ItemExtendMetalWareInfo ItemExtendMetalWareList = 7 [json_name = "ItemExtendMetalWareList"];
     */
    ItemExtendMetalWareList: ItemExtendMetalWareInfo[];
    /**
     * @generated from protobuf field: repeated prilus.ItemExtendRandomProductInfo ItemExtendRandomProductList = 8 [json_name = "ItemExtendRandomProductList"];
     */
    ItemExtendRandomProductList: ItemExtendRandomProductInfo[];
    /**
     * @generated from protobuf field: repeated prilus.ItemExtendSetItemDescInfo ItemExtendSetItemDescList = 9 [json_name = "ItemExtendSetItemDescList"];
     */
    ItemExtendSetItemDescList: ItemExtendSetItemDescInfo[];
    /**
     * @generated from protobuf field: repeated prilus.ItemExtendUpgradeInfo ItemExtendUpgradeList = 10 [json_name = "ItemExtendUpgradeList"];
     */
    ItemExtendUpgradeList: ItemExtendUpgradeInfo[];
    /**
     * @generated from protobuf field: repeated prilus.ItemInfo ItemList = 11 [json_name = "ItemList"];
     */
    ItemList: ItemInfo[];
    /**
     * @generated from protobuf field: repeated prilus.ItemUpgradeInfo ItemUpgradeList = 12 [json_name = "ItemUpgradeList"];
     */
    ItemUpgradeList: ItemUpgradeInfo[];
    /**
     * @generated from protobuf field: repeated prilus.MetalWareAbilityInfo MetalWareAbilityList = 13 [json_name = "MetalWareAbilityList"];
     */
    MetalWareAbilityList: MetalWareAbilityInfo[];
    /**
     * @generated from protobuf field: repeated prilus.MetalWareItemInfo MetalWareItemList = 14 [json_name = "MetalWareItemList"];
     */
    MetalWareItemList: MetalWareItemInfo[];
    /**
     * @generated from protobuf field: repeated prilus.MetalWareLevelInfo MetalWareLevelList = 15 [json_name = "MetalWareLevelList"];
     */
    MetalWareLevelList: MetalWareLevelInfo[];
    /**
     * @generated from protobuf field: repeated prilus.MiniatureInfo MiniatureList = 16 [json_name = "MiniatureList"];
     */
    MiniatureList: MiniatureInfo[];
    /**
     * @generated from protobuf field: repeated prilus.OptionSetInfo OptionSetList = 17 [json_name = "OptionSetList"];
     */
    OptionSetList: OptionSetInfo[];
    /**
     * @generated from protobuf field: repeated prilus.PetInfo PetList = 30 [json_name = "PetList"];
     */
    PetList: PetInfo[];
    /**
     * @generated from protobuf field: repeated prilus.ProductionInfo ProductionList = 18 [json_name = "ProductionList"];
     */
    ProductionList: ProductionInfo[];
    /**
     * @generated from protobuf field: repeated prilus.RaceInfo RaceList = 19 [json_name = "RaceList"];
     */
    RaceList: RaceInfo[];
    /**
     * @generated from protobuf field: repeated prilus.RandomTableInfo RandomTableList = 25 [json_name = "RandomTableList"];
     */
    RandomTableList: RandomTableInfo[];
    /**
     * @generated from protobuf field: repeated prilus.SetItemDescElementInfo SetItemDescElementList = 20 [json_name = "SetItemDescElementList"];
     */
    SetItemDescElementList: SetItemDescElementInfo[];
    /**
     * @generated from protobuf field: repeated prilus.SkillInfo SkillList = 21 [json_name = "SkillList"];
     */
    SkillList: SkillInfo[];
    /**
     * @generated from protobuf field: repeated prilus.SocialMotionInfo SocialMotionList = 22 [json_name = "SocialMotionList"];
     */
    SocialMotionList: SocialMotionInfo[];
    /**
     * @generated from protobuf field: repeated prilus.StringInfo StringTable = 23 [json_name = "StringTable"];
     */
    StringTable: StringInfo[];
    /**
     * @generated from protobuf field: repeated prilus.TalentInfo TalentList = 29 [json_name = "TalentList"];
     */
    TalentList: TalentInfo[];
    /**
     * @generated from protobuf field: repeated prilus.TitleInfo TitleList = 24 [json_name = "TitleList"];
     */
    TitleList: TitleInfo[];
    /**
     */
    Version?: ResourceVersion;
    /**
     * Custom Added Maps for Dynamic Loading
     */
    SkillNameMap?: { [key: number]: string };
    StatusNameMap?: { [key: number]: string };
    RaceNameMap?: { [key: number]: string };
}
/**
 * @generated from protobuf message prilus.ResourceVersion
 */
export interface ResourceVersion {
    /**
     * @generated from protobuf field: int64 CreatedAt = 1 [json_name = "CreatedAt"];
     */
    CreatedAt: number;
}
/**
 * @generated from protobuf message prilus.AchievementInfo
 */
export interface AchievementInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Hint = 3 [json_name = "Hint"];
     */
    Hint: string;
    /**
     * @generated from protobuf field: string Description = 4 [json_name = "Description"];
     */
    Description: string;
    /**
     * @generated from protobuf field: uint32 Point = 5 [json_name = "Point"];
     */
    Point: number;
    /**
     * @generated from protobuf field: uint32 Category = 6 [json_name = "Category"];
     */
    Category: number;
    /**
     * @generated from protobuf field: uint32 Prerequirement = 7 [json_name = "Prerequirement"];
     */
    Prerequirement: number;
    /**
     * @generated from protobuf field: bool Hidden = 8 [json_name = "Hidden"];
     */
    Hidden: boolean; // repeated uint32 ChildrenAchievement = 9;
}
/**
 * @generated from protobuf message prilus.BarterInfo
 */
export interface BarterInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: uint32 PostId = 3 [json_name = "PostId"];
     */
    PostId: number;
    /**
     * @generated from protobuf field: repeated prilus.ItemPrice Prices = 4 [json_name = "Prices"];
     */
    Prices: ItemPrice[];
    /**
     * @generated from protobuf field: string ResetType = 5 [json_name = "ResetType"];
     */
    ResetType: string;
    /**
     * @generated from protobuf field: uint32 Limit = 6 [json_name = "Limit"];
     */
    Limit: number;
}
/**
 * @generated from protobuf message prilus.ItemPrice
 */
export interface ItemPrice {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 Count = 2 [json_name = "Count"];
     */
    Count: number;
}
/**
 * @generated from protobuf message prilus.CharCondInfo
 */
export interface CharCondInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Desc = 3 [json_name = "Desc"];
     */
    Desc: string;
}
/**
 * @generated from protobuf message prilus.CharStyleData
 */
export interface CharStyleData {
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Races = 1 [json_name = "Races"];
     */
    Races: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo MaleFaces = 2 [json_name = "MaleFaces"];
     */
    MaleFaces: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo FemaleFaces = 3 [json_name = "FemaleFaces"];
     */
    FemaleFaces: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo SkinColors = 4 [json_name = "SkinColors"];
     */
    SkinColors: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo MaleHairs = 5 [json_name = "MaleHairs"];
     */
    MaleHairs: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo FemaleHairs = 6 [json_name = "FemaleHairs"];
     */
    FemaleHairs: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo HairColors = 7 [json_name = "HairColors"];
     */
    HairColors: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo EyeColors = 8 [json_name = "EyeColors"];
     */
    EyeColors: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo EyeTypes = 9 [json_name = "EyeTypes"];
     */
    EyeTypes: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo MouthTypes = 10 [json_name = "MouthTypes"];
     */
    MouthTypes: CharStyleInfo[];
}
/**
 * @generated from protobuf message prilus.CharStyleInfo
 */
export interface CharStyleInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Color = 3 [json_name = "Color"];
     */
    Color: string;
    /**
     * @generated from protobuf field: repeated uint32 AllowRaces = 4 [json_name = "AllowRaces"];
     */
    AllowRaces: number[];
    /**
     * @generated from protobuf field: uint32 ColorCount = 5 [json_name = "ColorCount"];
     */
    ColorCount: number;
    /**
     * @generated from protobuf field: repeated string DefaultColors = 6 [json_name = "DefaultColors"];
     */
    DefaultColors: string[];
}
/**
 * @generated from protobuf message prilus.EquipColData
 */
export interface EquipColData {
    /**
     * @generated from protobuf field: repeated uint32 Armor = 1 [json_name = "Armor"];
     */
    Armor: number[];
    /**
     * @generated from protobuf field: repeated uint32 Head = 2 [json_name = "Head"];
     */
    Head: number[];
    /**
     * @generated from protobuf field: repeated uint32 Glove = 3 [json_name = "Glove"];
     */
    Glove: number[];
    /**
     * @generated from protobuf field: repeated uint32 Shoes = 4 [json_name = "Shoes"];
     */
    Shoes: number[];
    /**
     * @generated from protobuf field: repeated uint32 Robe = 5 [json_name = "Robe"];
     */
    Robe: number[];
    /**
     * @generated from protobuf field: repeated uint32 Acc = 6 [json_name = "Acc"];
     */
    Acc: number[]; // 퍼핏, 헤일로
    /**
     * @generated from protobuf field: repeated uint32 FaceDeco = 7 [json_name = "FaceDeco"];
     */
    FaceDeco: number[];
    /**
     * @generated from protobuf field: repeated uint32 Tail = 8 [json_name = "Tail"];
     */
    Tail: number[];
    /**
     * @generated from protobuf field: repeated uint32 Chair = 9 [json_name = "Chair"];
     */
    Chair: number[];
}
/**
 * @generated from protobuf message prilus.EquipItemData
 */
export interface EquipItemData {
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Armor = 1 [json_name = "Armor"];
     */
    Armor: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Head = 2 [json_name = "Head"];
     */
    Head: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Glove = 3 [json_name = "Glove"];
     */
    Glove: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Shoes = 4 [json_name = "Shoes"];
     */
    Shoes: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Robe = 5 [json_name = "Robe"];
     */
    Robe: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Puppet = 6 [json_name = "Puppet"];
     */
    Puppet: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Halo = 7 [json_name = "Halo"];
     */
    Halo: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo FaceDeco = 8 [json_name = "FaceDeco"];
     */
    FaceDeco: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo Tail = 9 [json_name = "Tail"];
     */
    Tail: CharStyleInfo[];
    /**
     * @generated from protobuf field: repeated prilus.CharStyleInfo RightHand = 10 [json_name = "RightHand"];
     */
    RightHand: CharStyleInfo[];
}
/**
 * @generated from protobuf message prilus.FoodInfo
 */
export interface FoodInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 RecoverFood = 2 [json_name = "RecoverFood"];
     */
    RecoverFood: number;
    /**
     * @generated from protobuf field: int32 BoostStr = 3 [json_name = "BoostStr"];
     */
    BoostStr: number;
    /**
     * @generated from protobuf field: int32 BoostInt = 4 [json_name = "BoostInt"];
     */
    BoostInt: number;
    /**
     * @generated from protobuf field: int32 BoostDex = 5 [json_name = "BoostDex"];
     */
    BoostDex: number;
    /**
     * @generated from protobuf field: int32 BoostWill = 6 [json_name = "BoostWill"];
     */
    BoostWill: number;
    /**
     * @generated from protobuf field: int32 BoostLuck = 7 [json_name = "BoostLuck"];
     */
    BoostLuck: number;
    /**
     * @generated from protobuf field: int32 BoostLife = 8 [json_name = "BoostLife"];
     */
    BoostLife: number;
    /**
     * @generated from protobuf field: int32 BoostMana = 9 [json_name = "BoostMana"];
     */
    BoostMana: number;
    /**
     * @generated from protobuf field: int32 BoostStamina = 10 [json_name = "BoostStamina"];
     */
    BoostStamina: number;
    /**
     * @generated from protobuf field: int32 BoostWeight = 11 [json_name = "BoostWeight"];
     */
    BoostWeight: number;
    /**
     * @generated from protobuf field: int32 BoostUpper = 12 [json_name = "BoostUpper"];
     */
    BoostUpper: number;
    /**
     * @generated from protobuf field: int32 BoostLower = 13 [json_name = "BoostLower"];
     */
    BoostLower: number;
}
/**
 * @generated from protobuf message prilus.ItemExtendMetalWareInfo
 */
export interface ItemExtendMetalWareInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string EquipType = 2 [json_name = "EquipType"];
     */
    EquipType: string;
    /**
     * @generated from protobuf field: bool Human = 3 [json_name = "Human"];
     */
    Human: boolean;
    /**
     * @generated from protobuf field: bool Elf = 4 [json_name = "Elf"];
     */
    Elf: boolean;
    /**
     * @generated from protobuf field: bool Giant = 5 [json_name = "Giant"];
     */
    Giant: boolean;
}
/**
 * @generated from protobuf message prilus.ItemExtendRandomProductInfo
 */
export interface ItemExtendRandomProductInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: repeated prilus.RandomProductElement Elements = 2 [json_name = "Elements"];
     */
    Elements: RandomProductElement[];
}
/**
 * @generated from protobuf message prilus.RandomProductElement
 */
export interface RandomProductElement {
    /**
     * @generated from protobuf field: string Name = 1 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: uint32 Min = 2 [json_name = "Min"];
     */
    Min: number;
    /**
     * @generated from protobuf field: uint32 Max = 3 [json_name = "Max"];
     */
    Max: number;
}
/**
 * @generated from protobuf message prilus.ItemExtendSetItemDescInfo
 */
export interface ItemExtendSetItemDescInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: repeated prilus.SetItemDescElement Elements = 2 [json_name = "Elements"];
     */
    Elements: SetItemDescElement[];
    /**
     * @generated from protobuf field: repeated prilus.SetItemDescQuality Qualities = 3 [json_name = "Qualities"];
     */
    Qualities: SetItemDescQuality[];
}
/**
 * @generated from protobuf message prilus.SetItemDescElement
 */
export interface SetItemDescElement {
    /**
     * @generated from protobuf field: string Name = 1 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: uint32 Min = 2 [json_name = "Min"];
     */
    Min: number;
    /**
     * @generated from protobuf field: uint32 Max = 3 [json_name = "Max"];
     */
    Max: number;
}
/**
 * @generated from protobuf message prilus.SetItemDescQuality
 */
export interface SetItemDescQuality {
    /**
     * @generated from protobuf field: uint32 Threshold = 1 [json_name = "Threshold"];
     */
    Threshold: number;
    /**
     * @generated from protobuf field: repeated prilus.SetItemDescElement Bonus = 2 [json_name = "Bonus"];
     */
    Bonus: SetItemDescElement[];
}
/**
 * @generated from protobuf message prilus.ItemExtendUpgradeInfo
 */
export interface ItemExtendUpgradeInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 UpgradeMax = 2 [json_name = "UpgradeMax"];
     */
    UpgradeMax: number;
    /**
     * @generated from protobuf field: uint32 GemUpgradeMax = 3 [json_name = "GemUpgradeMax"];
     */
    GemUpgradeMax: number;
    /**
     * @generated from protobuf field: repeated uint32 UpgradeIds = 4 [json_name = "UpgradeIds"];
     */
    UpgradeIds: number[];
}
/**
 * @generated from protobuf message prilus.ItemInfo
 */
export interface ItemInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Desc = 3 [json_name = "Desc"];
     */
    Desc: string;
    /**
     * @generated from protobuf field: bool IsAuctionSearchable = 4 [json_name = "IsAuctionSearchable"];
     */
    IsAuctionSearchable: boolean;
    /**
     * @generated from protobuf field: bool HaveMesh = 5 [json_name = "HaveMesh"];
     */
    HaveMesh: boolean;
}
/**
 * @generated from protobuf message prilus.ItemUpgradeInfo
 */
export interface ItemUpgradeInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Desc = 3 [json_name = "Desc"];
     */
    Desc: string;
    /**
     * @generated from protobuf field: uint32 NeedEp = 4 [json_name = "NeedEp"];
     */
    NeedEp: number;
    /**
     * @generated from protobuf field: uint32 NeedGold = 5 [json_name = "NeedGold"];
     */
    NeedGold: number;
    /**
     * @generated from protobuf field: repeated prilus.ItemUpgradeGem NeedGems = 6 [json_name = "NeedGems"];
     */
    NeedGems: ItemUpgradeGem[];
    /**
     * @generated from protobuf field: uint32 UpgradedMin = 7 [json_name = "UpgradedMin"];
     */
    UpgradedMin: number;
    /**
     * @generated from protobuf field: uint32 UpgradedMax = 8 [json_name = "UpgradedMax"];
     */
    UpgradedMax: number;
    /**
     * @generated from protobuf field: repeated string AvailableNpcs = 9 [json_name = "AvailableNpcs"];
     */
    AvailableNpcs: string[];
    /**
     * @generated from protobuf field: repeated prilus.ItemUpgradeModifyStat ModifyStats = 10 [json_name = "ModifyStats"];
     */
    ModifyStats: ItemUpgradeModifyStat[];
    /**
     * @generated from protobuf field: repeated uint32 OptionSetIds = 11 [json_name = "OptionSetIds"];
     */
    OptionSetIds: number[];
    /**
     * @generated from protobuf field: prilus.ItemLuckyUpgrade LuckyUpgrade = 12 [json_name = "LuckyUpgrade"];
     */
    LuckyUpgrade?: ItemLuckyUpgrade;
    /**
     * @generated from protobuf field: bool Personalize = 13 [json_name = "Personalize"];
     */
    Personalize: boolean;
}
/**
 * @generated from protobuf message prilus.ItemUpgradeGem
 */
export interface ItemUpgradeGem {
    /**
     * @generated from protobuf field: string Name = 1 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: float Size = 2 [json_name = "Size"];
     */
    Size: number;
}
/**
 * @generated from protobuf message prilus.ItemUpgradeModifyStat
 */
export interface ItemUpgradeModifyStat {
    /**
     * @generated from protobuf field: string Name = 1 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: float Min = 2 [json_name = "Min"];
     */
    Min: number;
    /**
     * @generated from protobuf field: float Max = 3 [json_name = "Max"];
     */
    Max: number;
    /**
     * @generated from protobuf field: int32 Extra = 4 [json_name = "Extra"];
     */
    Extra: number;
}
/**
 * @generated from protobuf message prilus.ItemLuckyUpgrade
 */
export interface ItemLuckyUpgrade {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 CountTotalRate = 2 [json_name = "CountTotalRate"];
     */
    CountTotalRate: number;
    /**
     * @generated from protobuf field: repeated prilus.ItemLuckyUpgradeCountRate CountRates = 3 [json_name = "CountRates"];
     */
    CountRates: ItemLuckyUpgradeCountRate[];
    /**
     * @generated from protobuf field: uint32 RandomOptionTotalRate = 4 [json_name = "RandomOptionTotalRate"];
     */
    RandomOptionTotalRate: number;
    /**
     * @generated from protobuf field: repeated prilus.ItemLuckyUpgradeRandomOptionRate RandomOptionRates = 5 [json_name = "RandomOptionRates"];
     */
    RandomOptionRates: ItemLuckyUpgradeRandomOptionRate[];
    /**
     * @generated from protobuf field: repeated uint32 FixedOptions = 6 [json_name = "FixedOptions"];
     */
    FixedOptions: number[];
}
/**
 * @generated from protobuf message prilus.ItemLuckyUpgradeCountRate
 */
export interface ItemLuckyUpgradeCountRate {
    /**
     * @generated from protobuf field: uint32 Count = 1 [json_name = "Count"];
     */
    Count: number;
    /**
     * @generated from protobuf field: uint32 Rate = 2 [json_name = "Rate"];
     */
    Rate: number;
}
/**
 * @generated from protobuf message prilus.ItemLuckyUpgradeRandomOptionRate
 */
export interface ItemLuckyUpgradeRandomOptionRate {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 Rate = 2 [json_name = "Rate"];
     */
    Rate: number;
}
/**
 * @generated from protobuf message prilus.MetalWareAbilityInfo
 */
export interface MetalWareAbilityInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Desc = 2 [json_name = "Desc"];
     */
    Desc: string;
    /**
     * @generated from protobuf field: uint32 BaseMaxLevel = 3 [json_name = "BaseMaxLevel"];
     */
    BaseMaxLevel: number;
    /**
     * @generated from protobuf field: uint32 BaseMaxLevelAcc = 4 [json_name = "BaseMaxLevelAcc"];
     */
    BaseMaxLevelAcc: number;
    /**
     * @generated from protobuf field: uint32 BaseMaxLevelOH = 5 [json_name = "BaseMaxLevelOH"];
     */
    BaseMaxLevelOH: number;
    /**
     * @generated from protobuf field: string SubDesc = 6 [json_name = "SubDesc"];
     */
    SubDesc: string;
    /**
     * @generated from protobuf field: float InitialValue = 7 [json_name = "InitialValue"];
     */
    InitialValue: number;
    /**
     * @generated from protobuf field: float ValuePerLevel = 8 [json_name = "ValuePerLevel"];
     */
    ValuePerLevel: number;
    /**
     * @generated from protobuf field: bool LimitBreak = 9 [json_name = "LimitBreak"];
     */
    LimitBreak: boolean;
    /**
     * @generated from protobuf field: float Standard = 10 [json_name = "Standard"];
     */
    Standard: number;
    /**
     * @generated from protobuf field: map<string, bool> EquipFilterMap = 11 [json_name = "EquipFilterMap"];
     */
    EquipFilterMap: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: map<string, bool> TypeFilterMap = 12 [json_name = "TypeFilterMap"];
     */
    TypeFilterMap: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: bool Human = 13 [json_name = "Human"];
     */
    Human: boolean;
    /**
     * @generated from protobuf field: bool Elf = 14 [json_name = "Elf"];
     */
    Elf: boolean;
    /**
     * @generated from protobuf field: bool Giant = 15 [json_name = "Giant"];
     */
    Giant: boolean;
}
/**
 * @generated from protobuf message prilus.MetalWareItemInfo
 */
export interface MetalWareItemInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 ItemId = 2 [json_name = "ItemId"];
     */
    ItemId: number;
    /**
     * @generated from protobuf field: string Name = 3 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Desc = 4 [json_name = "Desc"];
     */
    Desc: string;
    /**
     * @generated from protobuf field: uint32 RateRank3 = 5 [json_name = "RateRank3"];
     */
    RateRank3: number;
    /**
     * @generated from protobuf field: uint32 RateRank2 = 6 [json_name = "RateRank2"];
     */
    RateRank2: number;
    /**
     * @generated from protobuf field: uint32 RateRank1 = 7 [json_name = "RateRank1"];
     */
    RateRank1: number;
    /**
     * @generated from protobuf field: uint32 RateAbility1 = 8 [json_name = "RateAbility1"];
     */
    RateAbility1: number;
    /**
     * @generated from protobuf field: uint32 RateAbility2 = 9 [json_name = "RateAbility2"];
     */
    RateAbility2: number;
    /**
     * @generated from protobuf field: uint32 RateAbility3 = 10 [json_name = "RateAbility3"];
     */
    RateAbility3: number;
    /**
     * @generated from protobuf field: uint32 LimitBreakRateFactor = 11 [json_name = "LimitBreakRateFactor"];
     */
    LimitBreakRateFactor: number;
    /**
     * @generated from protobuf field: uint32 MinLevelFactor = 12 [json_name = "MinLevelFactor"];
     */
    MinLevelFactor: number;
    /**
     * @generated from protobuf field: uint32 MaxLevelFactor = 13 [json_name = "MaxLevelFactor"];
     */
    MaxLevelFactor: number;
    /**
     * @generated from protobuf field: uint32 AbilityLimit = 14 [json_name = "AbilityLimit"];
     */
    AbilityLimit: number;
}
/**
 * @generated from protobuf message prilus.MetalWareLevelInfo
 */
export interface MetalWareLevelInfo {
    /**
     * @generated from protobuf field: uint32 Level = 1 [json_name = "Level"];
     */
    Level: number;
    /**
     * @generated from protobuf field: uint32 Rank3MinLevel = 2 [json_name = "Rank3MinLevel"];
     */
    Rank3MinLevel: number;
    /**
     * @generated from protobuf field: uint32 Rank3MaxLevel = 3 [json_name = "Rank3MaxLevel"];
     */
    Rank3MaxLevel: number;
    /**
     * @generated from protobuf field: uint32 Rank2MinLevel = 4 [json_name = "Rank2MinLevel"];
     */
    Rank2MinLevel: number;
    /**
     * @generated from protobuf field: uint32 Rank2MaxLevel = 5 [json_name = "Rank2MaxLevel"];
     */
    Rank2MaxLevel: number;
    /**
     * @generated from protobuf field: uint32 Rank1MinLevel = 6 [json_name = "Rank1MinLevel"];
     */
    Rank1MinLevel: number;
    /**
     * @generated from protobuf field: uint32 Rank1MaxLevel = 7 [json_name = "Rank1MaxLevel"];
     */
    Rank1MaxLevel: number;
    /**
     * @generated from protobuf field: uint32 LimitBreakMinLevel = 8 [json_name = "LimitBreakMinLevel"];
     */
    LimitBreakMinLevel: number;
    /**
     * @generated from protobuf field: uint32 LimitBreakMaxLevel = 9 [json_name = "LimitBreakMaxLevel"];
     */
    LimitBreakMaxLevel: number;
}
/**
 * @generated from protobuf message prilus.MiniatureInfo
 */
export interface MiniatureInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 ItemId = 2 [json_name = "ItemId"];
     */
    ItemId: number;
    /**
     * @generated from protobuf field: string Name = 3 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Description = 4 [json_name = "Description"];
     */
    Description: string;
    /**
     * @generated from protobuf field: map<string, uint32> BonusStatMap = 5 [json_name = "BonusStatMap"];
     */
    BonusStatMap: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: bool IsExtraMiniature = 6 [json_name = "IsExtraMiniature"];
     */
    IsExtraMiniature: boolean;
    /**
     * @generated from protobuf field: bool IsAuctionSearchable = 7 [json_name = "IsAuctionSearchable"];
     */
    IsAuctionSearchable: boolean;
}
/**
 * @generated from protobuf message prilus.OptionSetInfo
 */
export interface OptionSetInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Name2 = 3 [json_name = "Name2"];
     */
    Name2: string;
    /**
     * @generated from protobuf field: string Desc = 4 [json_name = "Desc"];
     */
    Desc: string;
    /**
     * @generated from protobuf field: uint32 Usage = 5 [json_name = "Usage"];
     */
    Usage: number;
    /**
     * @generated from protobuf field: uint32 Level = 6 [json_name = "Level"];
     */
    Level: number;
}
/**
 * @generated from protobuf message prilus.PetInfo
 */
export interface PetInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 LimitTime = 2 [json_name = "LimitTime"];
     */
    LimitTime: number;
    /**
     * 1살 기준
     *
     * @generated from protobuf field: prilus.PetStat MinLevelStat = 3 [json_name = "MinLevelStat"];
     */
    MinLevelStat?: PetStat;
    /**
     * @generated from protobuf field: prilus.PetStat MaxLevelStat = 4 [json_name = "MaxLevelStat"];
     */
    MaxLevelStat?: PetStat;
    /**
     * @generated from protobuf field: repeated prilus.PetSkill Skills = 5 [json_name = "Skills"];
     */
    Skills: PetSkill[];
}
/**
 * @generated from protobuf message prilus.PetSkill
 */
export interface PetSkill {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 Level = 2 [json_name = "Level"];
     */
    Level: number;
    /**
     * @generated from protobuf field: uint32 NeedPetLevel = 3 [json_name = "NeedPetLevel"];
     */
    NeedPetLevel: number;
}
/**
 * @generated from protobuf message prilus.PetStat
 */
export interface PetStat {
    /**
     * @generated from protobuf field: uint32 Str = 1 [json_name = "Str"];
     */
    Str: number;
    /**
     * @generated from protobuf field: uint32 Int = 2 [json_name = "Int"];
     */
    Int: number;
    /**
     * @generated from protobuf field: uint32 Dex = 3 [json_name = "Dex"];
     */
    Dex: number;
    /**
     * @generated from protobuf field: uint32 Will = 4 [json_name = "Will"];
     */
    Will: number;
    /**
     * @generated from protobuf field: uint32 Luck = 5 [json_name = "Luck"];
     */
    Luck: number;
    /**
     * @generated from protobuf field: uint32 Life = 6 [json_name = "Life"];
     */
    Life: number;
    /**
     * @generated from protobuf field: uint32 Mana = 7 [json_name = "Mana"];
     */
    Mana: number;
    /**
     * @generated from protobuf field: uint32 Stamina = 8 [json_name = "Stamina"];
     */
    Stamina: number;
}
/**
 * @generated from protobuf message prilus.ProductionInfo
 */
export interface ProductionInfo {
    /**
     * @generated from protobuf field: uint32 Type = 1 [json_name = "Type"];
     */
    Type: number; // production type, 0 ~ production, 0x10000 ~ manualform
    /**
     * @generated from protobuf field: uint32 ItemId = 2 [json_name = "ItemId"];
     */
    ItemId: number;
    /**
     * @generated from protobuf field: uint32 FormId = 3 [json_name = "FormId"];
     */
    FormId: number; // manualform only
    /**
     * @generated from protobuf field: uint32 Level = 4 [json_name = "Level"];
     */
    Level: number;
    /**
     * @generated from protobuf field: repeated prilus.ProductEssential Essentials = 5 [json_name = "Essentials"];
     */
    Essentials: ProductEssential[];
    /**
     * @generated from protobuf field: repeated prilus.ProductCompleteEssential CompleteEssentials = 6 [json_name = "CompleteEssentials"];
     */
    CompleteEssentials: ProductCompleteEssential[]; // manualform only
}
/**
 * @generated from protobuf message prilus.ProductEssential
 */
export interface ProductEssential {
    /**
     * @generated from protobuf field: repeated uint32 ItemIds = 1 [json_name = "ItemIds"];
     */
    ItemIds: number[];
    /**
     * @generated from protobuf field: uint32 Count = 2 [json_name = "Count"];
     */
    Count: number;
}
/**
 * @generated from protobuf message prilus.ProductCompleteEssential
 */
export interface ProductCompleteEssential {
    /**
     * @generated from protobuf field: repeated prilus.ProductEssential Essentials = 1 [json_name = "Essentials"];
     */
    Essentials: ProductEssential[];
    /**
     * @generated from protobuf field: string ExtraData = 2 [json_name = "ExtraData"];
     */
    ExtraData: string;
}
/**
 * @generated from protobuf message prilus.RaceInfo
 */
export interface RaceInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string ClassName = 3 [json_name = "ClassName"];
     */
    ClassName: string;
    /**
     * @generated from protobuf field: repeated prilus.RaceSkill Skills = 4 [json_name = "Skills"];
     */
    Skills: RaceSkill[];
    /**
     * @generated from protobuf field: repeated prilus.RaceWeakenSkill WeakenSkills = 5 [json_name = "WeakenSkills"];
     */
    WeakenSkills: RaceWeakenSkill[];
    /**
     * @generated from protobuf field: uint32 InventorySizeX = 6 [json_name = "InventorySizeX"];
     */
    InventorySizeX: number;
    /**
     * @generated from protobuf field: uint32 InventorySizeY = 7 [json_name = "InventorySizeY"];
     */
    InventorySizeY: number;
}
/**
 * @generated from protobuf message prilus.RaceSkill
 */
export interface RaceSkill {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 Level = 2 [json_name = "Level"];
     */
    Level: number;
}
/**
 * @generated from protobuf message prilus.RaceWeakenSkill
 */
export interface RaceWeakenSkill {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 DmgRate = 2 [json_name = "DmgRate"];
     */
    DmgRate: number;
}
/**
 * @generated from protobuf message prilus.RandomTableInfo
 */
export interface RandomTableInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: repeated prilus.RandomTableElement Elements = 3 [json_name = "Elements"];
     */
    Elements: RandomTableElement[];
    /**
     * @generated from protobuf field: uint32 TotalProb = 4 [json_name = "TotalProb"];
     */
    TotalProb: number;
}
/**
 * @generated from protobuf message prilus.RandomTableElement
 */
export interface RandomTableElement {
    /**
     * @generated from protobuf field: string Name = 1 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: uint32 Type = 2 [json_name = "Type"];
     */
    Type: number;
    /**
     * @generated from protobuf field: uint32 Min = 3 [json_name = "Min"];
     */
    Min: number;
    /**
     * @generated from protobuf field: uint32 Max = 4 [json_name = "Max"];
     */
    Max: number;
    /**
     * @generated from protobuf field: uint32 Extra = 5 [json_name = "Extra"];
     */
    Extra: number;
    /**
     * @generated from protobuf field: uint32 Prob = 6 [json_name = "Prob"];
     */
    Prob: number;
}
/**
 * @generated from protobuf message prilus.SetItemDescElementInfo
 */
export interface SetItemDescElementInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Key = 2 [json_name = "Key"];
     */
    Key: string;
    /**
     * @generated from protobuf field: string Name = 3 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Desc = 4 [json_name = "Desc"];
     */
    Desc: string;
}
/**
 * @generated from protobuf message prilus.SkillInfo
 */
export interface SkillInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Desc = 3 [json_name = "Desc"];
     */
    Desc: string;
    /**
     * @generated from protobuf field: uint32 Category = 5 [json_name = "Category"];
     */
    Category: number;
    /**
     * @generated from protobuf field: map<string, string> VariableMap = 4 [json_name = "VariableMap"];
     */
    VariableMap: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message prilus.SocialMotionInfo
 */
export interface SocialMotionInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: repeated uint32 AllowRaces = 3 [json_name = "AllowRaces"];
     */
    AllowRaces: number[];
}
/**
 * @generated from protobuf message prilus.StringInfo
 */
export interface StringInfo {
    /**
     * @generated from protobuf field: string Id = 1 [json_name = "Id"];
     */
    Id: string;
    /**
     * @generated from protobuf field: string Str = 2 [json_name = "Str"];
     */
    Str: string;
}
/**
 * @generated from protobuf message prilus.TalentInfo
 */
export interface TalentInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: string Name = 2 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string Subject = 3 [json_name = "Subject"];
     */
    Subject: string;
    /**
     * @generated from protobuf field: string Desc = 4 [json_name = "Desc"];
     */
    Desc: string;
    /**
     * @generated from protobuf field: repeated uint32 SkillIds = 5 [json_name = "SkillIds"];
     */
    SkillIds: number[];
}
/**
 * @generated from protobuf message prilus.TitleInfo
 */
export interface TitleInfo {
    /**
     * @generated from protobuf field: uint32 Id = 1 [json_name = "Id"];
     */
    Id: number;
    /**
     * @generated from protobuf field: uint32 Type = 2 [json_name = "Type"];
     */
    Type: number;
    /**
     * @generated from protobuf field: string Name = 3 [json_name = "Name"];
     */
    Name: string;
    /**
     * @generated from protobuf field: string MaleName = 4 [json_name = "MaleName"];
     */
    MaleName: string;
    /**
     * @generated from protobuf field: string FemaleName = 5 [json_name = "FemaleName"];
     */
    FemaleName: string;
    /**
     * @generated from protobuf field: string UniName = 6 [json_name = "UniName"];
     */
    UniName: string;
    /**
     * @generated from protobuf field: string Effect = 7 [json_name = "Effect"];
     */
    Effect: string;
    /**
     * @generated from protobuf field: uint32 Duration = 8 [json_name = "Duration"];
     */
    Duration: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class ResourceData$Type extends MessageType<ResourceData> {
    constructor() {
        super("prilus.ResourceData", [
            { no: 26, name: "AchievementList", kind: "message", localName: "AchievementList", jsonName: "AchievementList", repeat: 1 /*RepeatType.PACKED*/, T: () => AchievementInfo },
            { no: 27, name: "AchievementCategoryNameMap", kind: "map", localName: "AchievementCategoryNameMap", jsonName: "AchievementCategoryNameMap", K: 13 /*ScalarType.UINT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 1, name: "BarterList", kind: "message", localName: "BarterList", jsonName: "BarterList", repeat: 1 /*RepeatType.PACKED*/, T: () => BarterInfo },
            { no: 28, name: "CharCondList", kind: "message", localName: "CharCondList", jsonName: "CharCondList", repeat: 1 /*RepeatType.PACKED*/, T: () => CharCondInfo },
            { no: 2, name: "CharStyle", kind: "message", localName: "CharStyle", jsonName: "CharStyle", T: () => CharStyleData },
            { no: 3, name: "CommercePostNameMap", kind: "map", localName: "CommercePostNameMap", jsonName: "CommercePostNameMap", K: 13 /*ScalarType.UINT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 4, name: "EquipCol", kind: "message", localName: "EquipCol", jsonName: "EquipCol", T: () => EquipColData },
            { no: 5, name: "EquipItem", kind: "message", localName: "EquipItem", jsonName: "EquipItem", T: () => EquipItemData },
            { no: 6, name: "FoodList", kind: "message", localName: "FoodList", jsonName: "FoodList", repeat: 1 /*RepeatType.PACKED*/, T: () => FoodInfo },
            { no: 7, name: "ItemExtendMetalWareList", kind: "message", localName: "ItemExtendMetalWareList", jsonName: "ItemExtendMetalWareList", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemExtendMetalWareInfo },
            { no: 8, name: "ItemExtendRandomProductList", kind: "message", localName: "ItemExtendRandomProductList", jsonName: "ItemExtendRandomProductList", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemExtendRandomProductInfo },
            { no: 9, name: "ItemExtendSetItemDescList", kind: "message", localName: "ItemExtendSetItemDescList", jsonName: "ItemExtendSetItemDescList", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemExtendSetItemDescInfo },
            { no: 10, name: "ItemExtendUpgradeList", kind: "message", localName: "ItemExtendUpgradeList", jsonName: "ItemExtendUpgradeList", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemExtendUpgradeInfo },
            { no: 11, name: "ItemList", kind: "message", localName: "ItemList", jsonName: "ItemList", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemInfo },
            { no: 12, name: "ItemUpgradeList", kind: "message", localName: "ItemUpgradeList", jsonName: "ItemUpgradeList", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemUpgradeInfo },
            { no: 13, name: "MetalWareAbilityList", kind: "message", localName: "MetalWareAbilityList", jsonName: "MetalWareAbilityList", repeat: 1 /*RepeatType.PACKED*/, T: () => MetalWareAbilityInfo },
            { no: 14, name: "MetalWareItemList", kind: "message", localName: "MetalWareItemList", jsonName: "MetalWareItemList", repeat: 1 /*RepeatType.PACKED*/, T: () => MetalWareItemInfo },
            { no: 15, name: "MetalWareLevelList", kind: "message", localName: "MetalWareLevelList", jsonName: "MetalWareLevelList", repeat: 1 /*RepeatType.PACKED*/, T: () => MetalWareLevelInfo },
            { no: 16, name: "MiniatureList", kind: "message", localName: "MiniatureList", jsonName: "MiniatureList", repeat: 1 /*RepeatType.PACKED*/, T: () => MiniatureInfo },
            { no: 17, name: "OptionSetList", kind: "message", localName: "OptionSetList", jsonName: "OptionSetList", repeat: 1 /*RepeatType.PACKED*/, T: () => OptionSetInfo },
            { no: 30, name: "PetList", kind: "message", localName: "PetList", jsonName: "PetList", repeat: 1 /*RepeatType.PACKED*/, T: () => PetInfo },
            { no: 18, name: "ProductionList", kind: "message", localName: "ProductionList", jsonName: "ProductionList", repeat: 1 /*RepeatType.PACKED*/, T: () => ProductionInfo },
            { no: 19, name: "RaceList", kind: "message", localName: "RaceList", jsonName: "RaceList", repeat: 1 /*RepeatType.PACKED*/, T: () => RaceInfo },
            { no: 25, name: "RandomTableList", kind: "message", localName: "RandomTableList", jsonName: "RandomTableList", repeat: 1 /*RepeatType.PACKED*/, T: () => RandomTableInfo },
            { no: 20, name: "SetItemDescElementList", kind: "message", localName: "SetItemDescElementList", jsonName: "SetItemDescElementList", repeat: 1 /*RepeatType.PACKED*/, T: () => SetItemDescElementInfo },
            { no: 21, name: "SkillList", kind: "message", localName: "SkillList", jsonName: "SkillList", repeat: 1 /*RepeatType.PACKED*/, T: () => SkillInfo },
            { no: 22, name: "SocialMotionList", kind: "message", localName: "SocialMotionList", jsonName: "SocialMotionList", repeat: 1 /*RepeatType.PACKED*/, T: () => SocialMotionInfo },
            { no: 23, name: "StringTable", kind: "message", localName: "StringTable", jsonName: "StringTable", repeat: 1 /*RepeatType.PACKED*/, T: () => StringInfo },
            { no: 29, name: "TalentList", kind: "message", localName: "TalentList", jsonName: "TalentList", repeat: 1 /*RepeatType.PACKED*/, T: () => TalentInfo },
            { no: 24, name: "TitleList", kind: "message", localName: "TitleList", jsonName: "TitleList", repeat: 1 /*RepeatType.PACKED*/, T: () => TitleInfo },
            { no: 100, name: "Version", kind: "message", localName: "Version", jsonName: "Version", T: () => ResourceVersion }
        ]);
    }
    create(value?: PartialMessage<ResourceData>): ResourceData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.AchievementList = [];
        message.AchievementCategoryNameMap = {};
        message.BarterList = [];
        message.CharCondList = [];
        message.CommercePostNameMap = {};
        message.FoodList = [];
        message.ItemExtendMetalWareList = [];
        message.ItemExtendRandomProductList = [];
        message.ItemExtendSetItemDescList = [];
        message.ItemExtendUpgradeList = [];
        message.ItemList = [];
        message.ItemUpgradeList = [];
        message.MetalWareAbilityList = [];
        message.MetalWareItemList = [];
        message.MetalWareLevelList = [];
        message.MiniatureList = [];
        message.OptionSetList = [];
        message.PetList = [];
        message.ProductionList = [];
        message.RaceList = [];
        message.RandomTableList = [];
        message.SetItemDescElementList = [];
        message.SkillList = [];
        message.SocialMotionList = [];
        message.StringTable = [];
        message.TalentList = [];
        message.TitleList = [];
        if (value !== undefined)
            reflectionMergePartial<ResourceData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceData): ResourceData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated prilus.AchievementInfo AchievementList = 26 [json_name = "AchievementList"];*/ 26:
                    message.AchievementList.push(AchievementInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<uint32, string> AchievementCategoryNameMap = 27 [json_name = "AchievementCategoryNameMap"];*/ 27:
                    this.binaryReadMap27(message.AchievementCategoryNameMap, reader, options);
                    break;
                case /* repeated prilus.BarterInfo BarterList = 1 [json_name = "BarterList"];*/ 1:
                    message.BarterList.push(BarterInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharCondInfo CharCondList = 28 [json_name = "CharCondList"];*/ 28:
                    message.CharCondList.push(CharCondInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional prilus.CharStyleData CharStyle = 2 [json_name = "CharStyle"];*/ 2:
                    message.CharStyle = CharStyleData.internalBinaryRead(reader, reader.uint32(), options, message.CharStyle);
                    break;
                case /* map<uint32, string> CommercePostNameMap = 3 [json_name = "CommercePostNameMap"];*/ 3:
                    this.binaryReadMap3(message.CommercePostNameMap, reader, options);
                    break;
                case /* optional prilus.EquipColData EquipCol = 4 [json_name = "EquipCol"];*/ 4:
                    message.EquipCol = EquipColData.internalBinaryRead(reader, reader.uint32(), options, message.EquipCol);
                    break;
                case /* optional prilus.EquipItemData EquipItem = 5 [json_name = "EquipItem"];*/ 5:
                    message.EquipItem = EquipItemData.internalBinaryRead(reader, reader.uint32(), options, message.EquipItem);
                    break;
                case /* repeated prilus.FoodInfo FoodList = 6 [json_name = "FoodList"];*/ 6:
                    message.FoodList.push(FoodInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ItemExtendMetalWareInfo ItemExtendMetalWareList = 7 [json_name = "ItemExtendMetalWareList"];*/ 7:
                    message.ItemExtendMetalWareList.push(ItemExtendMetalWareInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ItemExtendRandomProductInfo ItemExtendRandomProductList = 8 [json_name = "ItemExtendRandomProductList"];*/ 8:
                    message.ItemExtendRandomProductList.push(ItemExtendRandomProductInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ItemExtendSetItemDescInfo ItemExtendSetItemDescList = 9 [json_name = "ItemExtendSetItemDescList"];*/ 9:
                    message.ItemExtendSetItemDescList.push(ItemExtendSetItemDescInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ItemExtendUpgradeInfo ItemExtendUpgradeList = 10 [json_name = "ItemExtendUpgradeList"];*/ 10:
                    message.ItemExtendUpgradeList.push(ItemExtendUpgradeInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ItemInfo ItemList = 11 [json_name = "ItemList"];*/ 11:
                    message.ItemList.push(ItemInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ItemUpgradeInfo ItemUpgradeList = 12 [json_name = "ItemUpgradeList"];*/ 12:
                    message.ItemUpgradeList.push(ItemUpgradeInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.MetalWareAbilityInfo MetalWareAbilityList = 13 [json_name = "MetalWareAbilityList"];*/ 13:
                    message.MetalWareAbilityList.push(MetalWareAbilityInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.MetalWareItemInfo MetalWareItemList = 14 [json_name = "MetalWareItemList"];*/ 14:
                    message.MetalWareItemList.push(MetalWareItemInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.MetalWareLevelInfo MetalWareLevelList = 15 [json_name = "MetalWareLevelList"];*/ 15:
                    message.MetalWareLevelList.push(MetalWareLevelInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.MiniatureInfo MiniatureList = 16 [json_name = "MiniatureList"];*/ 16:
                    message.MiniatureList.push(MiniatureInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.OptionSetInfo OptionSetList = 17 [json_name = "OptionSetList"];*/ 17:
                    message.OptionSetList.push(OptionSetInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.PetInfo PetList = 30 [json_name = "PetList"];*/ 30:
                    message.PetList.push(PetInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ProductionInfo ProductionList = 18 [json_name = "ProductionList"];*/ 18:
                    message.ProductionList.push(ProductionInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.RaceInfo RaceList = 19 [json_name = "RaceList"];*/ 19:
                    message.RaceList.push(RaceInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.RandomTableInfo RandomTableList = 25 [json_name = "RandomTableList"];*/ 25:
                    message.RandomTableList.push(RandomTableInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.SetItemDescElementInfo SetItemDescElementList = 20 [json_name = "SetItemDescElementList"];*/ 20:
                    message.SetItemDescElementList.push(SetItemDescElementInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.SkillInfo SkillList = 21 [json_name = "SkillList"];*/ 21:
                    message.SkillList.push(SkillInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.SocialMotionInfo SocialMotionList = 22 [json_name = "SocialMotionList"];*/ 22:
                    message.SocialMotionList.push(SocialMotionInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.StringInfo StringTable = 23 [json_name = "StringTable"];*/ 23:
                    message.StringTable.push(StringInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.TalentInfo TalentList = 29 [json_name = "TalentList"];*/ 29:
                    message.TalentList.push(TalentInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.TitleInfo TitleList = 24 [json_name = "TitleList"];*/ 24:
                    message.TitleList.push(TitleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* prilus.ResourceVersion Version = 100 [json_name = "Version"];*/ 100:
                    message.Version = ResourceVersion.internalBinaryRead(reader, reader.uint32(), options, message.Version);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap27(map: ResourceData["AchievementCategoryNameMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ResourceData["AchievementCategoryNameMap"] | undefined, val: ResourceData["AchievementCategoryNameMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.uint32();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field prilus.ResourceData.AchievementCategoryNameMap");
            }
        }
        map[key ?? 0] = val ?? "";
    }
    private binaryReadMap3(map: ResourceData["CommercePostNameMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ResourceData["CommercePostNameMap"] | undefined, val: ResourceData["CommercePostNameMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.uint32();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field prilus.ResourceData.CommercePostNameMap");
            }
        }
        map[key ?? 0] = val ?? "";
    }
    internalBinaryWrite(message: ResourceData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated prilus.AchievementInfo AchievementList = 26 [json_name = "AchievementList"]; */
        for (let i = 0; i < message.AchievementList.length; i++)
            AchievementInfo.internalBinaryWrite(message.AchievementList[i], writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* map<uint32, string> AchievementCategoryNameMap = 27 [json_name = "AchievementCategoryNameMap"]; */
        for (let k of globalThis.Object.keys(message.AchievementCategoryNameMap))
            writer.tag(27, WireType.LengthDelimited).fork().tag(1, WireType.Varint).uint32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.AchievementCategoryNameMap[k as any]).join();
        /* repeated prilus.BarterInfo BarterList = 1 [json_name = "BarterList"]; */
        for (let i = 0; i < message.BarterList.length; i++)
            BarterInfo.internalBinaryWrite(message.BarterList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharCondInfo CharCondList = 28 [json_name = "CharCondList"]; */
        for (let i = 0; i < message.CharCondList.length; i++)
            CharCondInfo.internalBinaryWrite(message.CharCondList[i], writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* optional prilus.CharStyleData CharStyle = 2 [json_name = "CharStyle"]; */
        if (message.CharStyle)
            CharStyleData.internalBinaryWrite(message.CharStyle, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<uint32, string> CommercePostNameMap = 3 [json_name = "CommercePostNameMap"]; */
        for (let k of globalThis.Object.keys(message.CommercePostNameMap))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.Varint).uint32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.CommercePostNameMap[k as any]).join();
        /* optional prilus.EquipColData EquipCol = 4 [json_name = "EquipCol"]; */
        if (message.EquipCol)
            EquipColData.internalBinaryWrite(message.EquipCol, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional prilus.EquipItemData EquipItem = 5 [json_name = "EquipItem"]; */
        if (message.EquipItem)
            EquipItemData.internalBinaryWrite(message.EquipItem, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.FoodInfo FoodList = 6 [json_name = "FoodList"]; */
        for (let i = 0; i < message.FoodList.length; i++)
            FoodInfo.internalBinaryWrite(message.FoodList[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ItemExtendMetalWareInfo ItemExtendMetalWareList = 7 [json_name = "ItemExtendMetalWareList"]; */
        for (let i = 0; i < message.ItemExtendMetalWareList.length; i++)
            ItemExtendMetalWareInfo.internalBinaryWrite(message.ItemExtendMetalWareList[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ItemExtendRandomProductInfo ItemExtendRandomProductList = 8 [json_name = "ItemExtendRandomProductList"]; */
        for (let i = 0; i < message.ItemExtendRandomProductList.length; i++)
            ItemExtendRandomProductInfo.internalBinaryWrite(message.ItemExtendRandomProductList[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ItemExtendSetItemDescInfo ItemExtendSetItemDescList = 9 [json_name = "ItemExtendSetItemDescList"]; */
        for (let i = 0; i < message.ItemExtendSetItemDescList.length; i++)
            ItemExtendSetItemDescInfo.internalBinaryWrite(message.ItemExtendSetItemDescList[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ItemExtendUpgradeInfo ItemExtendUpgradeList = 10 [json_name = "ItemExtendUpgradeList"]; */
        for (let i = 0; i < message.ItemExtendUpgradeList.length; i++)
            ItemExtendUpgradeInfo.internalBinaryWrite(message.ItemExtendUpgradeList[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ItemInfo ItemList = 11 [json_name = "ItemList"]; */
        for (let i = 0; i < message.ItemList.length; i++)
            ItemInfo.internalBinaryWrite(message.ItemList[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ItemUpgradeInfo ItemUpgradeList = 12 [json_name = "ItemUpgradeList"]; */
        for (let i = 0; i < message.ItemUpgradeList.length; i++)
            ItemUpgradeInfo.internalBinaryWrite(message.ItemUpgradeList[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.MetalWareAbilityInfo MetalWareAbilityList = 13 [json_name = "MetalWareAbilityList"]; */
        for (let i = 0; i < message.MetalWareAbilityList.length; i++)
            MetalWareAbilityInfo.internalBinaryWrite(message.MetalWareAbilityList[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.MetalWareItemInfo MetalWareItemList = 14 [json_name = "MetalWareItemList"]; */
        for (let i = 0; i < message.MetalWareItemList.length; i++)
            MetalWareItemInfo.internalBinaryWrite(message.MetalWareItemList[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.MetalWareLevelInfo MetalWareLevelList = 15 [json_name = "MetalWareLevelList"]; */
        for (let i = 0; i < message.MetalWareLevelList.length; i++)
            MetalWareLevelInfo.internalBinaryWrite(message.MetalWareLevelList[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.MiniatureInfo MiniatureList = 16 [json_name = "MiniatureList"]; */
        for (let i = 0; i < message.MiniatureList.length; i++)
            MiniatureInfo.internalBinaryWrite(message.MiniatureList[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.OptionSetInfo OptionSetList = 17 [json_name = "OptionSetList"]; */
        for (let i = 0; i < message.OptionSetList.length; i++)
            OptionSetInfo.internalBinaryWrite(message.OptionSetList[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.PetInfo PetList = 30 [json_name = "PetList"]; */
        for (let i = 0; i < message.PetList.length; i++)
            PetInfo.internalBinaryWrite(message.PetList[i], writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ProductionInfo ProductionList = 18 [json_name = "ProductionList"]; */
        for (let i = 0; i < message.ProductionList.length; i++)
            ProductionInfo.internalBinaryWrite(message.ProductionList[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.RaceInfo RaceList = 19 [json_name = "RaceList"]; */
        for (let i = 0; i < message.RaceList.length; i++)
            RaceInfo.internalBinaryWrite(message.RaceList[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.RandomTableInfo RandomTableList = 25 [json_name = "RandomTableList"]; */
        for (let i = 0; i < message.RandomTableList.length; i++)
            RandomTableInfo.internalBinaryWrite(message.RandomTableList[i], writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.SetItemDescElementInfo SetItemDescElementList = 20 [json_name = "SetItemDescElementList"]; */
        for (let i = 0; i < message.SetItemDescElementList.length; i++)
            SetItemDescElementInfo.internalBinaryWrite(message.SetItemDescElementList[i], writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.SkillInfo SkillList = 21 [json_name = "SkillList"]; */
        for (let i = 0; i < message.SkillList.length; i++)
            SkillInfo.internalBinaryWrite(message.SkillList[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.SocialMotionInfo SocialMotionList = 22 [json_name = "SocialMotionList"]; */
        for (let i = 0; i < message.SocialMotionList.length; i++)
            SocialMotionInfo.internalBinaryWrite(message.SocialMotionList[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.StringInfo StringTable = 23 [json_name = "StringTable"]; */
        for (let i = 0; i < message.StringTable.length; i++)
            StringInfo.internalBinaryWrite(message.StringTable[i], writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.TalentInfo TalentList = 29 [json_name = "TalentList"]; */
        for (let i = 0; i < message.TalentList.length; i++)
            TalentInfo.internalBinaryWrite(message.TalentList[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.TitleInfo TitleList = 24 [json_name = "TitleList"]; */
        for (let i = 0; i < message.TitleList.length; i++)
            TitleInfo.internalBinaryWrite(message.TitleList[i], writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* prilus.ResourceVersion Version = 100 [json_name = "Version"]; */
        if (message.Version)
            ResourceVersion.internalBinaryWrite(message.Version, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ResourceData
 */
export const ResourceData = new ResourceData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceVersion$Type extends MessageType<ResourceVersion> {
    constructor() {
        super("prilus.ResourceVersion", [
            { no: 1, name: "CreatedAt", kind: "scalar", localName: "CreatedAt", jsonName: "CreatedAt", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<ResourceVersion>): ResourceVersion {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.CreatedAt = 0;
        if (value !== undefined)
            reflectionMergePartial<ResourceVersion>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceVersion): ResourceVersion {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 CreatedAt = 1 [json_name = "CreatedAt"];*/ 1:
                    message.CreatedAt = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceVersion, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 CreatedAt = 1 [json_name = "CreatedAt"]; */
        if (message.CreatedAt !== 0)
            writer.tag(1, WireType.Varint).int64(message.CreatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ResourceVersion
 */
export const ResourceVersion = new ResourceVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AchievementInfo$Type extends MessageType<AchievementInfo> {
    constructor() {
        super("prilus.AchievementInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Hint", kind: "scalar", localName: "Hint", jsonName: "Hint", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "Description", kind: "scalar", localName: "Description", jsonName: "Description", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "Point", kind: "scalar", localName: "Point", jsonName: "Point", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "Category", kind: "scalar", localName: "Category", jsonName: "Category", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "Prerequirement", kind: "scalar", localName: "Prerequirement", jsonName: "Prerequirement", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "Hidden", kind: "scalar", localName: "Hidden", jsonName: "Hidden", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AchievementInfo>): AchievementInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Hint = "";
        message.Description = "";
        message.Point = 0;
        message.Category = 0;
        message.Prerequirement = 0;
        message.Hidden = false;
        if (value !== undefined)
            reflectionMergePartial<AchievementInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AchievementInfo): AchievementInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Hint = 3 [json_name = "Hint"];*/ 3:
                    message.Hint = reader.string();
                    break;
                case /* string Description = 4 [json_name = "Description"];*/ 4:
                    message.Description = reader.string();
                    break;
                case /* uint32 Point = 5 [json_name = "Point"];*/ 5:
                    message.Point = reader.uint32();
                    break;
                case /* uint32 Category = 6 [json_name = "Category"];*/ 6:
                    message.Category = reader.uint32();
                    break;
                case /* uint32 Prerequirement = 7 [json_name = "Prerequirement"];*/ 7:
                    message.Prerequirement = reader.uint32();
                    break;
                case /* bool Hidden = 8 [json_name = "Hidden"];*/ 8:
                    message.Hidden = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AchievementInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Hint = 3 [json_name = "Hint"]; */
        if (message.Hint !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Hint);
        /* string Description = 4 [json_name = "Description"]; */
        if (message.Description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.Description);
        /* uint32 Point = 5 [json_name = "Point"]; */
        if (message.Point !== 0)
            writer.tag(5, WireType.Varint).uint32(message.Point);
        /* uint32 Category = 6 [json_name = "Category"]; */
        if (message.Category !== 0)
            writer.tag(6, WireType.Varint).uint32(message.Category);
        /* uint32 Prerequirement = 7 [json_name = "Prerequirement"]; */
        if (message.Prerequirement !== 0)
            writer.tag(7, WireType.Varint).uint32(message.Prerequirement);
        /* bool Hidden = 8 [json_name = "Hidden"]; */
        if (message.Hidden !== false)
            writer.tag(8, WireType.Varint).bool(message.Hidden);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.AchievementInfo
 */
export const AchievementInfo = new AchievementInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BarterInfo$Type extends MessageType<BarterInfo> {
    constructor() {
        super("prilus.BarterInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "PostId", kind: "scalar", localName: "PostId", jsonName: "PostId", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "Prices", kind: "message", localName: "Prices", jsonName: "Prices", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemPrice },
            { no: 5, name: "ResetType", kind: "scalar", localName: "ResetType", jsonName: "ResetType", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "Limit", kind: "scalar", localName: "Limit", jsonName: "Limit", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<BarterInfo>): BarterInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.PostId = 0;
        message.Prices = [];
        message.ResetType = "";
        message.Limit = 0;
        if (value !== undefined)
            reflectionMergePartial<BarterInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BarterInfo): BarterInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* uint32 PostId = 3 [json_name = "PostId"];*/ 3:
                    message.PostId = reader.uint32();
                    break;
                case /* repeated prilus.ItemPrice Prices = 4 [json_name = "Prices"];*/ 4:
                    message.Prices.push(ItemPrice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string ResetType = 5 [json_name = "ResetType"];*/ 5:
                    message.ResetType = reader.string();
                    break;
                case /* uint32 Limit = 6 [json_name = "Limit"];*/ 6:
                    message.Limit = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BarterInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* uint32 PostId = 3 [json_name = "PostId"]; */
        if (message.PostId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.PostId);
        /* repeated prilus.ItemPrice Prices = 4 [json_name = "Prices"]; */
        for (let i = 0; i < message.Prices.length; i++)
            ItemPrice.internalBinaryWrite(message.Prices[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string ResetType = 5 [json_name = "ResetType"]; */
        if (message.ResetType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.ResetType);
        /* uint32 Limit = 6 [json_name = "Limit"]; */
        if (message.Limit !== 0)
            writer.tag(6, WireType.Varint).uint32(message.Limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.BarterInfo
 */
export const BarterInfo = new BarterInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemPrice$Type extends MessageType<ItemPrice> {
    constructor() {
        super("prilus.ItemPrice", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Count", kind: "scalar", localName: "Count", jsonName: "Count", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<ItemPrice>): ItemPrice {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Count = 0;
        if (value !== undefined)
            reflectionMergePartial<ItemPrice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemPrice): ItemPrice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 Count = 2 [json_name = "Count"];*/ 2:
                    message.Count = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemPrice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 Count = 2 [json_name = "Count"]; */
        if (message.Count !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemPrice
 */
export const ItemPrice = new ItemPrice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CharCondInfo$Type extends MessageType<CharCondInfo> {
    constructor() {
        super("prilus.CharCondInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CharCondInfo>): CharCondInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Desc = "";
        if (value !== undefined)
            reflectionMergePartial<CharCondInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CharCondInfo): CharCondInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Desc = 3 [json_name = "Desc"];*/ 3:
                    message.Desc = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CharCondInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Desc = 3 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Desc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.CharCondInfo
 */
export const CharCondInfo = new CharCondInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CharStyleData$Type extends MessageType<CharStyleData> {
    constructor() {
        super("prilus.CharStyleData", [
            { no: 1, name: "Races", kind: "message", localName: "Races", jsonName: "Races", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 2, name: "MaleFaces", kind: "message", localName: "MaleFaces", jsonName: "MaleFaces", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 3, name: "FemaleFaces", kind: "message", localName: "FemaleFaces", jsonName: "FemaleFaces", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 4, name: "SkinColors", kind: "message", localName: "SkinColors", jsonName: "SkinColors", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 5, name: "MaleHairs", kind: "message", localName: "MaleHairs", jsonName: "MaleHairs", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 6, name: "FemaleHairs", kind: "message", localName: "FemaleHairs", jsonName: "FemaleHairs", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 7, name: "HairColors", kind: "message", localName: "HairColors", jsonName: "HairColors", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 8, name: "EyeColors", kind: "message", localName: "EyeColors", jsonName: "EyeColors", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 9, name: "EyeTypes", kind: "message", localName: "EyeTypes", jsonName: "EyeTypes", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 10, name: "MouthTypes", kind: "message", localName: "MouthTypes", jsonName: "MouthTypes", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo }
        ]);
    }
    create(value?: PartialMessage<CharStyleData>): CharStyleData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Races = [];
        message.MaleFaces = [];
        message.FemaleFaces = [];
        message.SkinColors = [];
        message.MaleHairs = [];
        message.FemaleHairs = [];
        message.HairColors = [];
        message.EyeColors = [];
        message.EyeTypes = [];
        message.MouthTypes = [];
        if (value !== undefined)
            reflectionMergePartial<CharStyleData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CharStyleData): CharStyleData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated prilus.CharStyleInfo Races = 1 [json_name = "Races"];*/ 1:
                    message.Races.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo MaleFaces = 2 [json_name = "MaleFaces"];*/ 2:
                    message.MaleFaces.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo FemaleFaces = 3 [json_name = "FemaleFaces"];*/ 3:
                    message.FemaleFaces.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo SkinColors = 4 [json_name = "SkinColors"];*/ 4:
                    message.SkinColors.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo MaleHairs = 5 [json_name = "MaleHairs"];*/ 5:
                    message.MaleHairs.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo FemaleHairs = 6 [json_name = "FemaleHairs"];*/ 6:
                    message.FemaleHairs.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo HairColors = 7 [json_name = "HairColors"];*/ 7:
                    message.HairColors.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo EyeColors = 8 [json_name = "EyeColors"];*/ 8:
                    message.EyeColors.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo EyeTypes = 9 [json_name = "EyeTypes"];*/ 9:
                    message.EyeTypes.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo MouthTypes = 10 [json_name = "MouthTypes"];*/ 10:
                    message.MouthTypes.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CharStyleData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated prilus.CharStyleInfo Races = 1 [json_name = "Races"]; */
        for (let i = 0; i < message.Races.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Races[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo MaleFaces = 2 [json_name = "MaleFaces"]; */
        for (let i = 0; i < message.MaleFaces.length; i++)
            CharStyleInfo.internalBinaryWrite(message.MaleFaces[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo FemaleFaces = 3 [json_name = "FemaleFaces"]; */
        for (let i = 0; i < message.FemaleFaces.length; i++)
            CharStyleInfo.internalBinaryWrite(message.FemaleFaces[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo SkinColors = 4 [json_name = "SkinColors"]; */
        for (let i = 0; i < message.SkinColors.length; i++)
            CharStyleInfo.internalBinaryWrite(message.SkinColors[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo MaleHairs = 5 [json_name = "MaleHairs"]; */
        for (let i = 0; i < message.MaleHairs.length; i++)
            CharStyleInfo.internalBinaryWrite(message.MaleHairs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo FemaleHairs = 6 [json_name = "FemaleHairs"]; */
        for (let i = 0; i < message.FemaleHairs.length; i++)
            CharStyleInfo.internalBinaryWrite(message.FemaleHairs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo HairColors = 7 [json_name = "HairColors"]; */
        for (let i = 0; i < message.HairColors.length; i++)
            CharStyleInfo.internalBinaryWrite(message.HairColors[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo EyeColors = 8 [json_name = "EyeColors"]; */
        for (let i = 0; i < message.EyeColors.length; i++)
            CharStyleInfo.internalBinaryWrite(message.EyeColors[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo EyeTypes = 9 [json_name = "EyeTypes"]; */
        for (let i = 0; i < message.EyeTypes.length; i++)
            CharStyleInfo.internalBinaryWrite(message.EyeTypes[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo MouthTypes = 10 [json_name = "MouthTypes"]; */
        for (let i = 0; i < message.MouthTypes.length; i++)
            CharStyleInfo.internalBinaryWrite(message.MouthTypes[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.CharStyleData
 */
export const CharStyleData = new CharStyleData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CharStyleInfo$Type extends MessageType<CharStyleInfo> {
    constructor() {
        super("prilus.CharStyleInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Color", kind: "scalar", localName: "Color", jsonName: "Color", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "AllowRaces", kind: "scalar", localName: "AllowRaces", jsonName: "AllowRaces", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "ColorCount", kind: "scalar", localName: "ColorCount", jsonName: "ColorCount", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "DefaultColors", kind: "scalar", localName: "DefaultColors", jsonName: "DefaultColors", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CharStyleInfo>): CharStyleInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Color = "";
        message.AllowRaces = [];
        message.ColorCount = 0;
        message.DefaultColors = [];
        if (value !== undefined)
            reflectionMergePartial<CharStyleInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CharStyleInfo): CharStyleInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Color = 3 [json_name = "Color"];*/ 3:
                    message.Color = reader.string();
                    break;
                case /* repeated uint32 AllowRaces = 4 [json_name = "AllowRaces"];*/ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.AllowRaces.push(reader.uint32());
                    else
                        message.AllowRaces.push(reader.uint32());
                    break;
                case /* uint32 ColorCount = 5 [json_name = "ColorCount"];*/ 5:
                    message.ColorCount = reader.uint32();
                    break;
                case /* repeated string DefaultColors = 6 [json_name = "DefaultColors"];*/ 6:
                    message.DefaultColors.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CharStyleInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Color = 3 [json_name = "Color"]; */
        if (message.Color !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Color);
        /* repeated uint32 AllowRaces = 4 [json_name = "AllowRaces"]; */
        if (message.AllowRaces.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.AllowRaces.length; i++)
                writer.uint32(message.AllowRaces[i]);
            writer.join();
        }
        /* uint32 ColorCount = 5 [json_name = "ColorCount"]; */
        if (message.ColorCount !== 0)
            writer.tag(5, WireType.Varint).uint32(message.ColorCount);
        /* repeated string DefaultColors = 6 [json_name = "DefaultColors"]; */
        for (let i = 0; i < message.DefaultColors.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.DefaultColors[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.CharStyleInfo
 */
export const CharStyleInfo = new CharStyleInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EquipColData$Type extends MessageType<EquipColData> {
    constructor() {
        super("prilus.EquipColData", [
            { no: 1, name: "Armor", kind: "scalar", localName: "Armor", jsonName: "Armor", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Head", kind: "scalar", localName: "Head", jsonName: "Head", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Glove", kind: "scalar", localName: "Glove", jsonName: "Glove", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "Shoes", kind: "scalar", localName: "Shoes", jsonName: "Shoes", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "Robe", kind: "scalar", localName: "Robe", jsonName: "Robe", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "Acc", kind: "scalar", localName: "Acc", jsonName: "Acc", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "FaceDeco", kind: "scalar", localName: "FaceDeco", jsonName: "FaceDeco", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "Tail", kind: "scalar", localName: "Tail", jsonName: "Tail", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "Chair", kind: "scalar", localName: "Chair", jsonName: "Chair", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<EquipColData>): EquipColData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Armor = [];
        message.Head = [];
        message.Glove = [];
        message.Shoes = [];
        message.Robe = [];
        message.Acc = [];
        message.FaceDeco = [];
        message.Tail = [];
        message.Chair = [];
        if (value !== undefined)
            reflectionMergePartial<EquipColData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EquipColData): EquipColData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated uint32 Armor = 1 [json_name = "Armor"];*/ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Armor.push(reader.uint32());
                    else
                        message.Armor.push(reader.uint32());
                    break;
                case /* repeated uint32 Head = 2 [json_name = "Head"];*/ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Head.push(reader.uint32());
                    else
                        message.Head.push(reader.uint32());
                    break;
                case /* repeated uint32 Glove = 3 [json_name = "Glove"];*/ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Glove.push(reader.uint32());
                    else
                        message.Glove.push(reader.uint32());
                    break;
                case /* repeated uint32 Shoes = 4 [json_name = "Shoes"];*/ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Shoes.push(reader.uint32());
                    else
                        message.Shoes.push(reader.uint32());
                    break;
                case /* repeated uint32 Robe = 5 [json_name = "Robe"];*/ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Robe.push(reader.uint32());
                    else
                        message.Robe.push(reader.uint32());
                    break;
                case /* repeated uint32 Acc = 6 [json_name = "Acc"];*/ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Acc.push(reader.uint32());
                    else
                        message.Acc.push(reader.uint32());
                    break;
                case /* repeated uint32 FaceDeco = 7 [json_name = "FaceDeco"];*/ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.FaceDeco.push(reader.uint32());
                    else
                        message.FaceDeco.push(reader.uint32());
                    break;
                case /* repeated uint32 Tail = 8 [json_name = "Tail"];*/ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Tail.push(reader.uint32());
                    else
                        message.Tail.push(reader.uint32());
                    break;
                case /* repeated uint32 Chair = 9 [json_name = "Chair"];*/ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.Chair.push(reader.uint32());
                    else
                        message.Chair.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EquipColData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated uint32 Armor = 1 [json_name = "Armor"]; */
        if (message.Armor.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Armor.length; i++)
                writer.uint32(message.Armor[i]);
            writer.join();
        }
        /* repeated uint32 Head = 2 [json_name = "Head"]; */
        if (message.Head.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Head.length; i++)
                writer.uint32(message.Head[i]);
            writer.join();
        }
        /* repeated uint32 Glove = 3 [json_name = "Glove"]; */
        if (message.Glove.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Glove.length; i++)
                writer.uint32(message.Glove[i]);
            writer.join();
        }
        /* repeated uint32 Shoes = 4 [json_name = "Shoes"]; */
        if (message.Shoes.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Shoes.length; i++)
                writer.uint32(message.Shoes[i]);
            writer.join();
        }
        /* repeated uint32 Robe = 5 [json_name = "Robe"]; */
        if (message.Robe.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Robe.length; i++)
                writer.uint32(message.Robe[i]);
            writer.join();
        }
        /* repeated uint32 Acc = 6 [json_name = "Acc"]; */
        if (message.Acc.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Acc.length; i++)
                writer.uint32(message.Acc[i]);
            writer.join();
        }
        /* repeated uint32 FaceDeco = 7 [json_name = "FaceDeco"]; */
        if (message.FaceDeco.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.FaceDeco.length; i++)
                writer.uint32(message.FaceDeco[i]);
            writer.join();
        }
        /* repeated uint32 Tail = 8 [json_name = "Tail"]; */
        if (message.Tail.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Tail.length; i++)
                writer.uint32(message.Tail[i]);
            writer.join();
        }
        /* repeated uint32 Chair = 9 [json_name = "Chair"]; */
        if (message.Chair.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.Chair.length; i++)
                writer.uint32(message.Chair[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.EquipColData
 */
export const EquipColData = new EquipColData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EquipItemData$Type extends MessageType<EquipItemData> {
    constructor() {
        super("prilus.EquipItemData", [
            { no: 1, name: "Armor", kind: "message", localName: "Armor", jsonName: "Armor", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 2, name: "Head", kind: "message", localName: "Head", jsonName: "Head", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 3, name: "Glove", kind: "message", localName: "Glove", jsonName: "Glove", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 4, name: "Shoes", kind: "message", localName: "Shoes", jsonName: "Shoes", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 5, name: "Robe", kind: "message", localName: "Robe", jsonName: "Robe", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 6, name: "Puppet", kind: "message", localName: "Puppet", jsonName: "Puppet", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 7, name: "Halo", kind: "message", localName: "Halo", jsonName: "Halo", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 8, name: "FaceDeco", kind: "message", localName: "FaceDeco", jsonName: "FaceDeco", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 9, name: "Tail", kind: "message", localName: "Tail", jsonName: "Tail", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo },
            { no: 10, name: "RightHand", kind: "message", localName: "RightHand", jsonName: "RightHand", repeat: 1 /*RepeatType.PACKED*/, T: () => CharStyleInfo }
        ]);
    }
    create(value?: PartialMessage<EquipItemData>): EquipItemData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Armor = [];
        message.Head = [];
        message.Glove = [];
        message.Shoes = [];
        message.Robe = [];
        message.Puppet = [];
        message.Halo = [];
        message.FaceDeco = [];
        message.Tail = [];
        message.RightHand = [];
        if (value !== undefined)
            reflectionMergePartial<EquipItemData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EquipItemData): EquipItemData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated prilus.CharStyleInfo Armor = 1 [json_name = "Armor"];*/ 1:
                    message.Armor.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo Head = 2 [json_name = "Head"];*/ 2:
                    message.Head.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo Glove = 3 [json_name = "Glove"];*/ 3:
                    message.Glove.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo Shoes = 4 [json_name = "Shoes"];*/ 4:
                    message.Shoes.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo Robe = 5 [json_name = "Robe"];*/ 5:
                    message.Robe.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo Puppet = 6 [json_name = "Puppet"];*/ 6:
                    message.Puppet.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo Halo = 7 [json_name = "Halo"];*/ 7:
                    message.Halo.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo FaceDeco = 8 [json_name = "FaceDeco"];*/ 8:
                    message.FaceDeco.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo Tail = 9 [json_name = "Tail"];*/ 9:
                    message.Tail.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.CharStyleInfo RightHand = 10 [json_name = "RightHand"];*/ 10:
                    message.RightHand.push(CharStyleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EquipItemData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated prilus.CharStyleInfo Armor = 1 [json_name = "Armor"]; */
        for (let i = 0; i < message.Armor.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Armor[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo Head = 2 [json_name = "Head"]; */
        for (let i = 0; i < message.Head.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Head[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo Glove = 3 [json_name = "Glove"]; */
        for (let i = 0; i < message.Glove.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Glove[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo Shoes = 4 [json_name = "Shoes"]; */
        for (let i = 0; i < message.Shoes.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Shoes[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo Robe = 5 [json_name = "Robe"]; */
        for (let i = 0; i < message.Robe.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Robe[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo Puppet = 6 [json_name = "Puppet"]; */
        for (let i = 0; i < message.Puppet.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Puppet[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo Halo = 7 [json_name = "Halo"]; */
        for (let i = 0; i < message.Halo.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Halo[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo FaceDeco = 8 [json_name = "FaceDeco"]; */
        for (let i = 0; i < message.FaceDeco.length; i++)
            CharStyleInfo.internalBinaryWrite(message.FaceDeco[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo Tail = 9 [json_name = "Tail"]; */
        for (let i = 0; i < message.Tail.length; i++)
            CharStyleInfo.internalBinaryWrite(message.Tail[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.CharStyleInfo RightHand = 10 [json_name = "RightHand"]; */
        for (let i = 0; i < message.RightHand.length; i++)
            CharStyleInfo.internalBinaryWrite(message.RightHand[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.EquipItemData
 */
export const EquipItemData = new EquipItemData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FoodInfo$Type extends MessageType<FoodInfo> {
    constructor() {
        super("prilus.FoodInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "RecoverFood", kind: "scalar", localName: "RecoverFood", jsonName: "RecoverFood", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "BoostStr", kind: "scalar", localName: "BoostStr", jsonName: "BoostStr", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "BoostInt", kind: "scalar", localName: "BoostInt", jsonName: "BoostInt", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "BoostDex", kind: "scalar", localName: "BoostDex", jsonName: "BoostDex", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "BoostWill", kind: "scalar", localName: "BoostWill", jsonName: "BoostWill", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "BoostLuck", kind: "scalar", localName: "BoostLuck", jsonName: "BoostLuck", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "BoostLife", kind: "scalar", localName: "BoostLife", jsonName: "BoostLife", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "BoostMana", kind: "scalar", localName: "BoostMana", jsonName: "BoostMana", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "BoostStamina", kind: "scalar", localName: "BoostStamina", jsonName: "BoostStamina", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "BoostWeight", kind: "scalar", localName: "BoostWeight", jsonName: "BoostWeight", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "BoostUpper", kind: "scalar", localName: "BoostUpper", jsonName: "BoostUpper", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "BoostLower", kind: "scalar", localName: "BoostLower", jsonName: "BoostLower", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<FoodInfo>): FoodInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.RecoverFood = 0;
        message.BoostStr = 0;
        message.BoostInt = 0;
        message.BoostDex = 0;
        message.BoostWill = 0;
        message.BoostLuck = 0;
        message.BoostLife = 0;
        message.BoostMana = 0;
        message.BoostStamina = 0;
        message.BoostWeight = 0;
        message.BoostUpper = 0;
        message.BoostLower = 0;
        if (value !== undefined)
            reflectionMergePartial<FoodInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FoodInfo): FoodInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 RecoverFood = 2 [json_name = "RecoverFood"];*/ 2:
                    message.RecoverFood = reader.uint32();
                    break;
                case /* int32 BoostStr = 3 [json_name = "BoostStr"];*/ 3:
                    message.BoostStr = reader.int32();
                    break;
                case /* int32 BoostInt = 4 [json_name = "BoostInt"];*/ 4:
                    message.BoostInt = reader.int32();
                    break;
                case /* int32 BoostDex = 5 [json_name = "BoostDex"];*/ 5:
                    message.BoostDex = reader.int32();
                    break;
                case /* int32 BoostWill = 6 [json_name = "BoostWill"];*/ 6:
                    message.BoostWill = reader.int32();
                    break;
                case /* int32 BoostLuck = 7 [json_name = "BoostLuck"];*/ 7:
                    message.BoostLuck = reader.int32();
                    break;
                case /* int32 BoostLife = 8 [json_name = "BoostLife"];*/ 8:
                    message.BoostLife = reader.int32();
                    break;
                case /* int32 BoostMana = 9 [json_name = "BoostMana"];*/ 9:
                    message.BoostMana = reader.int32();
                    break;
                case /* int32 BoostStamina = 10 [json_name = "BoostStamina"];*/ 10:
                    message.BoostStamina = reader.int32();
                    break;
                case /* int32 BoostWeight = 11 [json_name = "BoostWeight"];*/ 11:
                    message.BoostWeight = reader.int32();
                    break;
                case /* int32 BoostUpper = 12 [json_name = "BoostUpper"];*/ 12:
                    message.BoostUpper = reader.int32();
                    break;
                case /* int32 BoostLower = 13 [json_name = "BoostLower"];*/ 13:
                    message.BoostLower = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FoodInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 RecoverFood = 2 [json_name = "RecoverFood"]; */
        if (message.RecoverFood !== 0)
            writer.tag(2, WireType.Varint).uint32(message.RecoverFood);
        /* int32 BoostStr = 3 [json_name = "BoostStr"]; */
        if (message.BoostStr !== 0)
            writer.tag(3, WireType.Varint).int32(message.BoostStr);
        /* int32 BoostInt = 4 [json_name = "BoostInt"]; */
        if (message.BoostInt !== 0)
            writer.tag(4, WireType.Varint).int32(message.BoostInt);
        /* int32 BoostDex = 5 [json_name = "BoostDex"]; */
        if (message.BoostDex !== 0)
            writer.tag(5, WireType.Varint).int32(message.BoostDex);
        /* int32 BoostWill = 6 [json_name = "BoostWill"]; */
        if (message.BoostWill !== 0)
            writer.tag(6, WireType.Varint).int32(message.BoostWill);
        /* int32 BoostLuck = 7 [json_name = "BoostLuck"]; */
        if (message.BoostLuck !== 0)
            writer.tag(7, WireType.Varint).int32(message.BoostLuck);
        /* int32 BoostLife = 8 [json_name = "BoostLife"]; */
        if (message.BoostLife !== 0)
            writer.tag(8, WireType.Varint).int32(message.BoostLife);
        /* int32 BoostMana = 9 [json_name = "BoostMana"]; */
        if (message.BoostMana !== 0)
            writer.tag(9, WireType.Varint).int32(message.BoostMana);
        /* int32 BoostStamina = 10 [json_name = "BoostStamina"]; */
        if (message.BoostStamina !== 0)
            writer.tag(10, WireType.Varint).int32(message.BoostStamina);
        /* int32 BoostWeight = 11 [json_name = "BoostWeight"]; */
        if (message.BoostWeight !== 0)
            writer.tag(11, WireType.Varint).int32(message.BoostWeight);
        /* int32 BoostUpper = 12 [json_name = "BoostUpper"]; */
        if (message.BoostUpper !== 0)
            writer.tag(12, WireType.Varint).int32(message.BoostUpper);
        /* int32 BoostLower = 13 [json_name = "BoostLower"]; */
        if (message.BoostLower !== 0)
            writer.tag(13, WireType.Varint).int32(message.BoostLower);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.FoodInfo
 */
export const FoodInfo = new FoodInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemExtendMetalWareInfo$Type extends MessageType<ItemExtendMetalWareInfo> {
    constructor() {
        super("prilus.ItemExtendMetalWareInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "EquipType", kind: "scalar", localName: "EquipType", jsonName: "EquipType", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Human", kind: "scalar", localName: "Human", jsonName: "Human", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "Elf", kind: "scalar", localName: "Elf", jsonName: "Elf", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "Giant", kind: "scalar", localName: "Giant", jsonName: "Giant", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ItemExtendMetalWareInfo>): ItemExtendMetalWareInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.EquipType = "";
        message.Human = false;
        message.Elf = false;
        message.Giant = false;
        if (value !== undefined)
            reflectionMergePartial<ItemExtendMetalWareInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemExtendMetalWareInfo): ItemExtendMetalWareInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string EquipType = 2 [json_name = "EquipType"];*/ 2:
                    message.EquipType = reader.string();
                    break;
                case /* bool Human = 3 [json_name = "Human"];*/ 3:
                    message.Human = reader.bool();
                    break;
                case /* bool Elf = 4 [json_name = "Elf"];*/ 4:
                    message.Elf = reader.bool();
                    break;
                case /* bool Giant = 5 [json_name = "Giant"];*/ 5:
                    message.Giant = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemExtendMetalWareInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string EquipType = 2 [json_name = "EquipType"]; */
        if (message.EquipType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.EquipType);
        /* bool Human = 3 [json_name = "Human"]; */
        if (message.Human !== false)
            writer.tag(3, WireType.Varint).bool(message.Human);
        /* bool Elf = 4 [json_name = "Elf"]; */
        if (message.Elf !== false)
            writer.tag(4, WireType.Varint).bool(message.Elf);
        /* bool Giant = 5 [json_name = "Giant"]; */
        if (message.Giant !== false)
            writer.tag(5, WireType.Varint).bool(message.Giant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemExtendMetalWareInfo
 */
export const ItemExtendMetalWareInfo = new ItemExtendMetalWareInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemExtendRandomProductInfo$Type extends MessageType<ItemExtendRandomProductInfo> {
    constructor() {
        super("prilus.ItemExtendRandomProductInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Elements", kind: "message", localName: "Elements", jsonName: "Elements", repeat: 1 /*RepeatType.PACKED*/, T: () => RandomProductElement }
        ]);
    }
    create(value?: PartialMessage<ItemExtendRandomProductInfo>): ItemExtendRandomProductInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Elements = [];
        if (value !== undefined)
            reflectionMergePartial<ItemExtendRandomProductInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemExtendRandomProductInfo): ItemExtendRandomProductInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* repeated prilus.RandomProductElement Elements = 2 [json_name = "Elements"];*/ 2:
                    message.Elements.push(RandomProductElement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemExtendRandomProductInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* repeated prilus.RandomProductElement Elements = 2 [json_name = "Elements"]; */
        for (let i = 0; i < message.Elements.length; i++)
            RandomProductElement.internalBinaryWrite(message.Elements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemExtendRandomProductInfo
 */
export const ItemExtendRandomProductInfo = new ItemExtendRandomProductInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RandomProductElement$Type extends MessageType<RandomProductElement> {
    constructor() {
        super("prilus.RandomProductElement", [
            { no: 1, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Min", kind: "scalar", localName: "Min", jsonName: "Min", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Max", kind: "scalar", localName: "Max", jsonName: "Max", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RandomProductElement>): RandomProductElement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Name = "";
        message.Min = 0;
        message.Max = 0;
        if (value !== undefined)
            reflectionMergePartial<RandomProductElement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RandomProductElement): RandomProductElement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string Name = 1 [json_name = "Name"];*/ 1:
                    message.Name = reader.string();
                    break;
                case /* uint32 Min = 2 [json_name = "Min"];*/ 2:
                    message.Min = reader.uint32();
                    break;
                case /* uint32 Max = 3 [json_name = "Max"];*/ 3:
                    message.Max = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RandomProductElement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string Name = 1 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.Name);
        /* uint32 Min = 2 [json_name = "Min"]; */
        if (message.Min !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Min);
        /* uint32 Max = 3 [json_name = "Max"]; */
        if (message.Max !== 0)
            writer.tag(3, WireType.Varint).uint32(message.Max);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.RandomProductElement
 */
export const RandomProductElement = new RandomProductElement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemExtendSetItemDescInfo$Type extends MessageType<ItemExtendSetItemDescInfo> {
    constructor() {
        super("prilus.ItemExtendSetItemDescInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Elements", kind: "message", localName: "Elements", jsonName: "Elements", repeat: 1 /*RepeatType.PACKED*/, T: () => SetItemDescElement },
            { no: 3, name: "Qualities", kind: "message", localName: "Qualities", jsonName: "Qualities", repeat: 1 /*RepeatType.PACKED*/, T: () => SetItemDescQuality }
        ]);
    }
    create(value?: PartialMessage<ItemExtendSetItemDescInfo>): ItemExtendSetItemDescInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Elements = [];
        message.Qualities = [];
        if (value !== undefined)
            reflectionMergePartial<ItemExtendSetItemDescInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemExtendSetItemDescInfo): ItemExtendSetItemDescInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* repeated prilus.SetItemDescElement Elements = 2 [json_name = "Elements"];*/ 2:
                    message.Elements.push(SetItemDescElement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.SetItemDescQuality Qualities = 3 [json_name = "Qualities"];*/ 3:
                    message.Qualities.push(SetItemDescQuality.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemExtendSetItemDescInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* repeated prilus.SetItemDescElement Elements = 2 [json_name = "Elements"]; */
        for (let i = 0; i < message.Elements.length; i++)
            SetItemDescElement.internalBinaryWrite(message.Elements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.SetItemDescQuality Qualities = 3 [json_name = "Qualities"]; */
        for (let i = 0; i < message.Qualities.length; i++)
            SetItemDescQuality.internalBinaryWrite(message.Qualities[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemExtendSetItemDescInfo
 */
export const ItemExtendSetItemDescInfo = new ItemExtendSetItemDescInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetItemDescElement$Type extends MessageType<SetItemDescElement> {
    constructor() {
        super("prilus.SetItemDescElement", [
            { no: 1, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Min", kind: "scalar", localName: "Min", jsonName: "Min", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Max", kind: "scalar", localName: "Max", jsonName: "Max", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<SetItemDescElement>): SetItemDescElement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Name = "";
        message.Min = 0;
        message.Max = 0;
        if (value !== undefined)
            reflectionMergePartial<SetItemDescElement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetItemDescElement): SetItemDescElement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string Name = 1 [json_name = "Name"];*/ 1:
                    message.Name = reader.string();
                    break;
                case /* uint32 Min = 2 [json_name = "Min"];*/ 2:
                    message.Min = reader.uint32();
                    break;
                case /* uint32 Max = 3 [json_name = "Max"];*/ 3:
                    message.Max = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetItemDescElement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string Name = 1 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.Name);
        /* uint32 Min = 2 [json_name = "Min"]; */
        if (message.Min !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Min);
        /* uint32 Max = 3 [json_name = "Max"]; */
        if (message.Max !== 0)
            writer.tag(3, WireType.Varint).uint32(message.Max);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.SetItemDescElement
 */
export const SetItemDescElement = new SetItemDescElement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetItemDescQuality$Type extends MessageType<SetItemDescQuality> {
    constructor() {
        super("prilus.SetItemDescQuality", [
            { no: 1, name: "Threshold", kind: "scalar", localName: "Threshold", jsonName: "Threshold", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Bonus", kind: "message", localName: "Bonus", jsonName: "Bonus", repeat: 1 /*RepeatType.PACKED*/, T: () => SetItemDescElement }
        ]);
    }
    create(value?: PartialMessage<SetItemDescQuality>): SetItemDescQuality {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Threshold = 0;
        message.Bonus = [];
        if (value !== undefined)
            reflectionMergePartial<SetItemDescQuality>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetItemDescQuality): SetItemDescQuality {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Threshold = 1 [json_name = "Threshold"];*/ 1:
                    message.Threshold = reader.uint32();
                    break;
                case /* repeated prilus.SetItemDescElement Bonus = 2 [json_name = "Bonus"];*/ 2:
                    message.Bonus.push(SetItemDescElement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetItemDescQuality, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Threshold = 1 [json_name = "Threshold"]; */
        if (message.Threshold !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Threshold);
        /* repeated prilus.SetItemDescElement Bonus = 2 [json_name = "Bonus"]; */
        for (let i = 0; i < message.Bonus.length; i++)
            SetItemDescElement.internalBinaryWrite(message.Bonus[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.SetItemDescQuality
 */
export const SetItemDescQuality = new SetItemDescQuality$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemExtendUpgradeInfo$Type extends MessageType<ItemExtendUpgradeInfo> {
    constructor() {
        super("prilus.ItemExtendUpgradeInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "UpgradeMax", kind: "scalar", localName: "UpgradeMax", jsonName: "UpgradeMax", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "GemUpgradeMax", kind: "scalar", localName: "GemUpgradeMax", jsonName: "GemUpgradeMax", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "UpgradeIds", kind: "scalar", localName: "UpgradeIds", jsonName: "UpgradeIds", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<ItemExtendUpgradeInfo>): ItemExtendUpgradeInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.UpgradeMax = 0;
        message.GemUpgradeMax = 0;
        message.UpgradeIds = [];
        if (value !== undefined)
            reflectionMergePartial<ItemExtendUpgradeInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemExtendUpgradeInfo): ItemExtendUpgradeInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 UpgradeMax = 2 [json_name = "UpgradeMax"];*/ 2:
                    message.UpgradeMax = reader.uint32();
                    break;
                case /* uint32 GemUpgradeMax = 3 [json_name = "GemUpgradeMax"];*/ 3:
                    message.GemUpgradeMax = reader.uint32();
                    break;
                case /* repeated uint32 UpgradeIds = 4 [json_name = "UpgradeIds"];*/ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.UpgradeIds.push(reader.uint32());
                    else
                        message.UpgradeIds.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemExtendUpgradeInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 UpgradeMax = 2 [json_name = "UpgradeMax"]; */
        if (message.UpgradeMax !== 0)
            writer.tag(2, WireType.Varint).uint32(message.UpgradeMax);
        /* uint32 GemUpgradeMax = 3 [json_name = "GemUpgradeMax"]; */
        if (message.GemUpgradeMax !== 0)
            writer.tag(3, WireType.Varint).uint32(message.GemUpgradeMax);
        /* repeated uint32 UpgradeIds = 4 [json_name = "UpgradeIds"]; */
        if (message.UpgradeIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.UpgradeIds.length; i++)
                writer.uint32(message.UpgradeIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemExtendUpgradeInfo
 */
export const ItemExtendUpgradeInfo = new ItemExtendUpgradeInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemInfo$Type extends MessageType<ItemInfo> {
    constructor() {
        super("prilus.ItemInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "IsAuctionSearchable", kind: "scalar", localName: "IsAuctionSearchable", jsonName: "IsAuctionSearchable", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "HaveMesh", kind: "scalar", localName: "HaveMesh", jsonName: "HaveMesh", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ItemInfo>): ItemInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Desc = "";
        message.IsAuctionSearchable = false;
        message.HaveMesh = false;
        if (value !== undefined)
            reflectionMergePartial<ItemInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemInfo): ItemInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Desc = 3 [json_name = "Desc"];*/ 3:
                    message.Desc = reader.string();
                    break;
                case /* bool IsAuctionSearchable = 4 [json_name = "IsAuctionSearchable"];*/ 4:
                    message.IsAuctionSearchable = reader.bool();
                    break;
                case /* bool HaveMesh = 5 [json_name = "HaveMesh"];*/ 5:
                    message.HaveMesh = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Desc = 3 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Desc);
        /* bool IsAuctionSearchable = 4 [json_name = "IsAuctionSearchable"]; */
        if (message.IsAuctionSearchable !== false)
            writer.tag(4, WireType.Varint).bool(message.IsAuctionSearchable);
        /* bool HaveMesh = 5 [json_name = "HaveMesh"]; */
        if (message.HaveMesh !== false)
            writer.tag(5, WireType.Varint).bool(message.HaveMesh);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemInfo
 */
export const ItemInfo = new ItemInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemUpgradeInfo$Type extends MessageType<ItemUpgradeInfo> {
    constructor() {
        super("prilus.ItemUpgradeInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "NeedEp", kind: "scalar", localName: "NeedEp", jsonName: "NeedEp", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "NeedGold", kind: "scalar", localName: "NeedGold", jsonName: "NeedGold", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "NeedGems", kind: "message", localName: "NeedGems", jsonName: "NeedGems", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemUpgradeGem },
            { no: 7, name: "UpgradedMin", kind: "scalar", localName: "UpgradedMin", jsonName: "UpgradedMin", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "UpgradedMax", kind: "scalar", localName: "UpgradedMax", jsonName: "UpgradedMax", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "AvailableNpcs", kind: "scalar", localName: "AvailableNpcs", jsonName: "AvailableNpcs", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "ModifyStats", kind: "message", localName: "ModifyStats", jsonName: "ModifyStats", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemUpgradeModifyStat },
            { no: 11, name: "OptionSetIds", kind: "scalar", localName: "OptionSetIds", jsonName: "OptionSetIds", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 12, name: "LuckyUpgrade", kind: "message", localName: "LuckyUpgrade", jsonName: "LuckyUpgrade", T: () => ItemLuckyUpgrade },
            { no: 13, name: "Personalize", kind: "scalar", localName: "Personalize", jsonName: "Personalize", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ItemUpgradeInfo>): ItemUpgradeInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Desc = "";
        message.NeedEp = 0;
        message.NeedGold = 0;
        message.NeedGems = [];
        message.UpgradedMin = 0;
        message.UpgradedMax = 0;
        message.AvailableNpcs = [];
        message.ModifyStats = [];
        message.OptionSetIds = [];
        message.Personalize = false;
        if (value !== undefined)
            reflectionMergePartial<ItemUpgradeInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemUpgradeInfo): ItemUpgradeInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Desc = 3 [json_name = "Desc"];*/ 3:
                    message.Desc = reader.string();
                    break;
                case /* uint32 NeedEp = 4 [json_name = "NeedEp"];*/ 4:
                    message.NeedEp = reader.uint32();
                    break;
                case /* uint32 NeedGold = 5 [json_name = "NeedGold"];*/ 5:
                    message.NeedGold = reader.uint32();
                    break;
                case /* repeated prilus.ItemUpgradeGem NeedGems = 6 [json_name = "NeedGems"];*/ 6:
                    message.NeedGems.push(ItemUpgradeGem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* uint32 UpgradedMin = 7 [json_name = "UpgradedMin"];*/ 7:
                    message.UpgradedMin = reader.uint32();
                    break;
                case /* uint32 UpgradedMax = 8 [json_name = "UpgradedMax"];*/ 8:
                    message.UpgradedMax = reader.uint32();
                    break;
                case /* repeated string AvailableNpcs = 9 [json_name = "AvailableNpcs"];*/ 9:
                    message.AvailableNpcs.push(reader.string());
                    break;
                case /* repeated prilus.ItemUpgradeModifyStat ModifyStats = 10 [json_name = "ModifyStats"];*/ 10:
                    message.ModifyStats.push(ItemUpgradeModifyStat.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated uint32 OptionSetIds = 11 [json_name = "OptionSetIds"];*/ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.OptionSetIds.push(reader.uint32());
                    else
                        message.OptionSetIds.push(reader.uint32());
                    break;
                case /* prilus.ItemLuckyUpgrade LuckyUpgrade = 12 [json_name = "LuckyUpgrade"];*/ 12:
                    message.LuckyUpgrade = ItemLuckyUpgrade.internalBinaryRead(reader, reader.uint32(), options, message.LuckyUpgrade);
                    break;
                case /* bool Personalize = 13 [json_name = "Personalize"];*/ 13:
                    message.Personalize = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemUpgradeInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Desc = 3 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Desc);
        /* uint32 NeedEp = 4 [json_name = "NeedEp"]; */
        if (message.NeedEp !== 0)
            writer.tag(4, WireType.Varint).uint32(message.NeedEp);
        /* uint32 NeedGold = 5 [json_name = "NeedGold"]; */
        if (message.NeedGold !== 0)
            writer.tag(5, WireType.Varint).uint32(message.NeedGold);
        /* repeated prilus.ItemUpgradeGem NeedGems = 6 [json_name = "NeedGems"]; */
        for (let i = 0; i < message.NeedGems.length; i++)
            ItemUpgradeGem.internalBinaryWrite(message.NeedGems[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* uint32 UpgradedMin = 7 [json_name = "UpgradedMin"]; */
        if (message.UpgradedMin !== 0)
            writer.tag(7, WireType.Varint).uint32(message.UpgradedMin);
        /* uint32 UpgradedMax = 8 [json_name = "UpgradedMax"]; */
        if (message.UpgradedMax !== 0)
            writer.tag(8, WireType.Varint).uint32(message.UpgradedMax);
        /* repeated string AvailableNpcs = 9 [json_name = "AvailableNpcs"]; */
        for (let i = 0; i < message.AvailableNpcs.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.AvailableNpcs[i]);
        /* repeated prilus.ItemUpgradeModifyStat ModifyStats = 10 [json_name = "ModifyStats"]; */
        for (let i = 0; i < message.ModifyStats.length; i++)
            ItemUpgradeModifyStat.internalBinaryWrite(message.ModifyStats[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated uint32 OptionSetIds = 11 [json_name = "OptionSetIds"]; */
        if (message.OptionSetIds.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.OptionSetIds.length; i++)
                writer.uint32(message.OptionSetIds[i]);
            writer.join();
        }
        /* prilus.ItemLuckyUpgrade LuckyUpgrade = 12 [json_name = "LuckyUpgrade"]; */
        if (message.LuckyUpgrade)
            ItemLuckyUpgrade.internalBinaryWrite(message.LuckyUpgrade, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool Personalize = 13 [json_name = "Personalize"]; */
        if (message.Personalize !== false)
            writer.tag(13, WireType.Varint).bool(message.Personalize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemUpgradeInfo
 */
export const ItemUpgradeInfo = new ItemUpgradeInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemUpgradeGem$Type extends MessageType<ItemUpgradeGem> {
    constructor() {
        super("prilus.ItemUpgradeGem", [
            { no: 1, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Size", kind: "scalar", localName: "Size", jsonName: "Size", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<ItemUpgradeGem>): ItemUpgradeGem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Name = "";
        message.Size = 0;
        if (value !== undefined)
            reflectionMergePartial<ItemUpgradeGem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemUpgradeGem): ItemUpgradeGem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string Name = 1 [json_name = "Name"];*/ 1:
                    message.Name = reader.string();
                    break;
                case /* float Size = 2 [json_name = "Size"];*/ 2:
                    message.Size = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemUpgradeGem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string Name = 1 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.Name);
        /* float Size = 2 [json_name = "Size"]; */
        if (message.Size !== 0)
            writer.tag(2, WireType.Bit32).float(message.Size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemUpgradeGem
 */
export const ItemUpgradeGem = new ItemUpgradeGem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemUpgradeModifyStat$Type extends MessageType<ItemUpgradeModifyStat> {
    constructor() {
        super("prilus.ItemUpgradeModifyStat", [
            { no: 1, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Min", kind: "scalar", localName: "Min", jsonName: "Min", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "Max", kind: "scalar", localName: "Max", jsonName: "Max", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "Extra", kind: "scalar", localName: "Extra", jsonName: "Extra", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ItemUpgradeModifyStat>): ItemUpgradeModifyStat {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Name = "";
        message.Min = 0;
        message.Max = 0;
        message.Extra = 0;
        if (value !== undefined)
            reflectionMergePartial<ItemUpgradeModifyStat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemUpgradeModifyStat): ItemUpgradeModifyStat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string Name = 1 [json_name = "Name"];*/ 1:
                    message.Name = reader.string();
                    break;
                case /* float Min = 2 [json_name = "Min"];*/ 2:
                    message.Min = reader.float();
                    break;
                case /* float Max = 3 [json_name = "Max"];*/ 3:
                    message.Max = reader.float();
                    break;
                case /* int32 Extra = 4 [json_name = "Extra"];*/ 4:
                    message.Extra = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemUpgradeModifyStat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string Name = 1 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.Name);
        /* float Min = 2 [json_name = "Min"]; */
        if (message.Min !== 0)
            writer.tag(2, WireType.Bit32).float(message.Min);
        /* float Max = 3 [json_name = "Max"]; */
        if (message.Max !== 0)
            writer.tag(3, WireType.Bit32).float(message.Max);
        /* int32 Extra = 4 [json_name = "Extra"]; */
        if (message.Extra !== 0)
            writer.tag(4, WireType.Varint).int32(message.Extra);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemUpgradeModifyStat
 */
export const ItemUpgradeModifyStat = new ItemUpgradeModifyStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemLuckyUpgrade$Type extends MessageType<ItemLuckyUpgrade> {
    constructor() {
        super("prilus.ItemLuckyUpgrade", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "CountTotalRate", kind: "scalar", localName: "CountTotalRate", jsonName: "CountTotalRate", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "CountRates", kind: "message", localName: "CountRates", jsonName: "CountRates", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemLuckyUpgradeCountRate },
            { no: 4, name: "RandomOptionTotalRate", kind: "scalar", localName: "RandomOptionTotalRate", jsonName: "RandomOptionTotalRate", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "RandomOptionRates", kind: "message", localName: "RandomOptionRates", jsonName: "RandomOptionRates", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemLuckyUpgradeRandomOptionRate },
            { no: 6, name: "FixedOptions", kind: "scalar", localName: "FixedOptions", jsonName: "FixedOptions", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<ItemLuckyUpgrade>): ItemLuckyUpgrade {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.CountTotalRate = 0;
        message.CountRates = [];
        message.RandomOptionTotalRate = 0;
        message.RandomOptionRates = [];
        message.FixedOptions = [];
        if (value !== undefined)
            reflectionMergePartial<ItemLuckyUpgrade>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemLuckyUpgrade): ItemLuckyUpgrade {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 CountTotalRate = 2 [json_name = "CountTotalRate"];*/ 2:
                    message.CountTotalRate = reader.uint32();
                    break;
                case /* repeated prilus.ItemLuckyUpgradeCountRate CountRates = 3 [json_name = "CountRates"];*/ 3:
                    message.CountRates.push(ItemLuckyUpgradeCountRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* uint32 RandomOptionTotalRate = 4 [json_name = "RandomOptionTotalRate"];*/ 4:
                    message.RandomOptionTotalRate = reader.uint32();
                    break;
                case /* repeated prilus.ItemLuckyUpgradeRandomOptionRate RandomOptionRates = 5 [json_name = "RandomOptionRates"];*/ 5:
                    message.RandomOptionRates.push(ItemLuckyUpgradeRandomOptionRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated uint32 FixedOptions = 6 [json_name = "FixedOptions"];*/ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.FixedOptions.push(reader.uint32());
                    else
                        message.FixedOptions.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemLuckyUpgrade, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 CountTotalRate = 2 [json_name = "CountTotalRate"]; */
        if (message.CountTotalRate !== 0)
            writer.tag(2, WireType.Varint).uint32(message.CountTotalRate);
        /* repeated prilus.ItemLuckyUpgradeCountRate CountRates = 3 [json_name = "CountRates"]; */
        for (let i = 0; i < message.CountRates.length; i++)
            ItemLuckyUpgradeCountRate.internalBinaryWrite(message.CountRates[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* uint32 RandomOptionTotalRate = 4 [json_name = "RandomOptionTotalRate"]; */
        if (message.RandomOptionTotalRate !== 0)
            writer.tag(4, WireType.Varint).uint32(message.RandomOptionTotalRate);
        /* repeated prilus.ItemLuckyUpgradeRandomOptionRate RandomOptionRates = 5 [json_name = "RandomOptionRates"]; */
        for (let i = 0; i < message.RandomOptionRates.length; i++)
            ItemLuckyUpgradeRandomOptionRate.internalBinaryWrite(message.RandomOptionRates[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated uint32 FixedOptions = 6 [json_name = "FixedOptions"]; */
        if (message.FixedOptions.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.FixedOptions.length; i++)
                writer.uint32(message.FixedOptions[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemLuckyUpgrade
 */
export const ItemLuckyUpgrade = new ItemLuckyUpgrade$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemLuckyUpgradeCountRate$Type extends MessageType<ItemLuckyUpgradeCountRate> {
    constructor() {
        super("prilus.ItemLuckyUpgradeCountRate", [
            { no: 1, name: "Count", kind: "scalar", localName: "Count", jsonName: "Count", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Rate", kind: "scalar", localName: "Rate", jsonName: "Rate", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<ItemLuckyUpgradeCountRate>): ItemLuckyUpgradeCountRate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Count = 0;
        message.Rate = 0;
        if (value !== undefined)
            reflectionMergePartial<ItemLuckyUpgradeCountRate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemLuckyUpgradeCountRate): ItemLuckyUpgradeCountRate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Count = 1 [json_name = "Count"];*/ 1:
                    message.Count = reader.uint32();
                    break;
                case /* uint32 Rate = 2 [json_name = "Rate"];*/ 2:
                    message.Rate = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemLuckyUpgradeCountRate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Count = 1 [json_name = "Count"]; */
        if (message.Count !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Count);
        /* uint32 Rate = 2 [json_name = "Rate"]; */
        if (message.Rate !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Rate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemLuckyUpgradeCountRate
 */
export const ItemLuckyUpgradeCountRate = new ItemLuckyUpgradeCountRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemLuckyUpgradeRandomOptionRate$Type extends MessageType<ItemLuckyUpgradeRandomOptionRate> {
    constructor() {
        super("prilus.ItemLuckyUpgradeRandomOptionRate", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Rate", kind: "scalar", localName: "Rate", jsonName: "Rate", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<ItemLuckyUpgradeRandomOptionRate>): ItemLuckyUpgradeRandomOptionRate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Rate = 0;
        if (value !== undefined)
            reflectionMergePartial<ItemLuckyUpgradeRandomOptionRate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemLuckyUpgradeRandomOptionRate): ItemLuckyUpgradeRandomOptionRate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 Rate = 2 [json_name = "Rate"];*/ 2:
                    message.Rate = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemLuckyUpgradeRandomOptionRate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 Rate = 2 [json_name = "Rate"]; */
        if (message.Rate !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Rate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ItemLuckyUpgradeRandomOptionRate
 */
export const ItemLuckyUpgradeRandomOptionRate = new ItemLuckyUpgradeRandomOptionRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetalWareAbilityInfo$Type extends MessageType<MetalWareAbilityInfo> {
    constructor() {
        super("prilus.MetalWareAbilityInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "BaseMaxLevel", kind: "scalar", localName: "BaseMaxLevel", jsonName: "BaseMaxLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "BaseMaxLevelAcc", kind: "scalar", localName: "BaseMaxLevelAcc", jsonName: "BaseMaxLevelAcc", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "BaseMaxLevelOH", kind: "scalar", localName: "BaseMaxLevelOH", jsonName: "BaseMaxLevelOH", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "SubDesc", kind: "scalar", localName: "SubDesc", jsonName: "SubDesc", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "InitialValue", kind: "scalar", localName: "InitialValue", jsonName: "InitialValue", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "ValuePerLevel", kind: "scalar", localName: "ValuePerLevel", jsonName: "ValuePerLevel", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "LimitBreak", kind: "scalar", localName: "LimitBreak", jsonName: "LimitBreak", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "Standard", kind: "scalar", localName: "Standard", jsonName: "Standard", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "EquipFilterMap", kind: "map", localName: "EquipFilterMap", jsonName: "EquipFilterMap", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 12, name: "TypeFilterMap", kind: "map", localName: "TypeFilterMap", jsonName: "TypeFilterMap", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 13, name: "Human", kind: "scalar", localName: "Human", jsonName: "Human", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "Elf", kind: "scalar", localName: "Elf", jsonName: "Elf", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "Giant", kind: "scalar", localName: "Giant", jsonName: "Giant", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<MetalWareAbilityInfo>): MetalWareAbilityInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Desc = "";
        message.BaseMaxLevel = 0;
        message.BaseMaxLevelAcc = 0;
        message.BaseMaxLevelOH = 0;
        message.SubDesc = "";
        message.InitialValue = 0;
        message.ValuePerLevel = 0;
        message.LimitBreak = false;
        message.Standard = 0;
        message.EquipFilterMap = {};
        message.TypeFilterMap = {};
        message.Human = false;
        message.Elf = false;
        message.Giant = false;
        if (value !== undefined)
            reflectionMergePartial<MetalWareAbilityInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetalWareAbilityInfo): MetalWareAbilityInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Desc = 2 [json_name = "Desc"];*/ 2:
                    message.Desc = reader.string();
                    break;
                case /* uint32 BaseMaxLevel = 3 [json_name = "BaseMaxLevel"];*/ 3:
                    message.BaseMaxLevel = reader.uint32();
                    break;
                case /* uint32 BaseMaxLevelAcc = 4 [json_name = "BaseMaxLevelAcc"];*/ 4:
                    message.BaseMaxLevelAcc = reader.uint32();
                    break;
                case /* uint32 BaseMaxLevelOH = 5 [json_name = "BaseMaxLevelOH"];*/ 5:
                    message.BaseMaxLevelOH = reader.uint32();
                    break;
                case /* string SubDesc = 6 [json_name = "SubDesc"];*/ 6:
                    message.SubDesc = reader.string();
                    break;
                case /* float InitialValue = 7 [json_name = "InitialValue"];*/ 7:
                    message.InitialValue = reader.float();
                    break;
                case /* float ValuePerLevel = 8 [json_name = "ValuePerLevel"];*/ 8:
                    message.ValuePerLevel = reader.float();
                    break;
                case /* bool LimitBreak = 9 [json_name = "LimitBreak"];*/ 9:
                    message.LimitBreak = reader.bool();
                    break;
                case /* float Standard = 10 [json_name = "Standard"];*/ 10:
                    message.Standard = reader.float();
                    break;
                case /* map<string, bool> EquipFilterMap = 11 [json_name = "EquipFilterMap"];*/ 11:
                    this.binaryReadMap11(message.EquipFilterMap, reader, options);
                    break;
                case /* map<string, bool> TypeFilterMap = 12 [json_name = "TypeFilterMap"];*/ 12:
                    this.binaryReadMap12(message.TypeFilterMap, reader, options);
                    break;
                case /* bool Human = 13 [json_name = "Human"];*/ 13:
                    message.Human = reader.bool();
                    break;
                case /* bool Elf = 14 [json_name = "Elf"];*/ 14:
                    message.Elf = reader.bool();
                    break;
                case /* bool Giant = 15 [json_name = "Giant"];*/ 15:
                    message.Giant = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap11(map: MetalWareAbilityInfo["EquipFilterMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof MetalWareAbilityInfo["EquipFilterMap"] | undefined, val: MetalWareAbilityInfo["EquipFilterMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field prilus.MetalWareAbilityInfo.EquipFilterMap");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap12(map: MetalWareAbilityInfo["TypeFilterMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof MetalWareAbilityInfo["TypeFilterMap"] | undefined, val: MetalWareAbilityInfo["TypeFilterMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field prilus.MetalWareAbilityInfo.TypeFilterMap");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    internalBinaryWrite(message: MetalWareAbilityInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Desc = 2 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Desc);
        /* uint32 BaseMaxLevel = 3 [json_name = "BaseMaxLevel"]; */
        if (message.BaseMaxLevel !== 0)
            writer.tag(3, WireType.Varint).uint32(message.BaseMaxLevel);
        /* uint32 BaseMaxLevelAcc = 4 [json_name = "BaseMaxLevelAcc"]; */
        if (message.BaseMaxLevelAcc !== 0)
            writer.tag(4, WireType.Varint).uint32(message.BaseMaxLevelAcc);
        /* uint32 BaseMaxLevelOH = 5 [json_name = "BaseMaxLevelOH"]; */
        if (message.BaseMaxLevelOH !== 0)
            writer.tag(5, WireType.Varint).uint32(message.BaseMaxLevelOH);
        /* string SubDesc = 6 [json_name = "SubDesc"]; */
        if (message.SubDesc !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.SubDesc);
        /* float InitialValue = 7 [json_name = "InitialValue"]; */
        if (message.InitialValue !== 0)
            writer.tag(7, WireType.Bit32).float(message.InitialValue);
        /* float ValuePerLevel = 8 [json_name = "ValuePerLevel"]; */
        if (message.ValuePerLevel !== 0)
            writer.tag(8, WireType.Bit32).float(message.ValuePerLevel);
        /* bool LimitBreak = 9 [json_name = "LimitBreak"]; */
        if (message.LimitBreak !== false)
            writer.tag(9, WireType.Varint).bool(message.LimitBreak);
        /* float Standard = 10 [json_name = "Standard"]; */
        if (message.Standard !== 0)
            writer.tag(10, WireType.Bit32).float(message.Standard);
        /* map<string, bool> EquipFilterMap = 11 [json_name = "EquipFilterMap"]; */
        for (let k of globalThis.Object.keys(message.EquipFilterMap))
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.EquipFilterMap[k]).join();
        /* map<string, bool> TypeFilterMap = 12 [json_name = "TypeFilterMap"]; */
        for (let k of globalThis.Object.keys(message.TypeFilterMap))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.TypeFilterMap[k]).join();
        /* bool Human = 13 [json_name = "Human"]; */
        if (message.Human !== false)
            writer.tag(13, WireType.Varint).bool(message.Human);
        /* bool Elf = 14 [json_name = "Elf"]; */
        if (message.Elf !== false)
            writer.tag(14, WireType.Varint).bool(message.Elf);
        /* bool Giant = 15 [json_name = "Giant"]; */
        if (message.Giant !== false)
            writer.tag(15, WireType.Varint).bool(message.Giant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.MetalWareAbilityInfo
 */
export const MetalWareAbilityInfo = new MetalWareAbilityInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetalWareItemInfo$Type extends MessageType<MetalWareItemInfo> {
    constructor() {
        super("prilus.MetalWareItemInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "ItemId", kind: "scalar", localName: "ItemId", jsonName: "ItemId", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "RateRank3", kind: "scalar", localName: "RateRank3", jsonName: "RateRank3", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "RateRank2", kind: "scalar", localName: "RateRank2", jsonName: "RateRank2", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "RateRank1", kind: "scalar", localName: "RateRank1", jsonName: "RateRank1", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "RateAbility1", kind: "scalar", localName: "RateAbility1", jsonName: "RateAbility1", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "RateAbility2", kind: "scalar", localName: "RateAbility2", jsonName: "RateAbility2", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "RateAbility3", kind: "scalar", localName: "RateAbility3", jsonName: "RateAbility3", T: 13 /*ScalarType.UINT32*/ },
            { no: 11, name: "LimitBreakRateFactor", kind: "scalar", localName: "LimitBreakRateFactor", jsonName: "LimitBreakRateFactor", T: 13 /*ScalarType.UINT32*/ },
            { no: 12, name: "MinLevelFactor", kind: "scalar", localName: "MinLevelFactor", jsonName: "MinLevelFactor", T: 13 /*ScalarType.UINT32*/ },
            { no: 13, name: "MaxLevelFactor", kind: "scalar", localName: "MaxLevelFactor", jsonName: "MaxLevelFactor", T: 13 /*ScalarType.UINT32*/ },
            { no: 14, name: "AbilityLimit", kind: "scalar", localName: "AbilityLimit", jsonName: "AbilityLimit", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<MetalWareItemInfo>): MetalWareItemInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.ItemId = 0;
        message.Name = "";
        message.Desc = "";
        message.RateRank3 = 0;
        message.RateRank2 = 0;
        message.RateRank1 = 0;
        message.RateAbility1 = 0;
        message.RateAbility2 = 0;
        message.RateAbility3 = 0;
        message.LimitBreakRateFactor = 0;
        message.MinLevelFactor = 0;
        message.MaxLevelFactor = 0;
        message.AbilityLimit = 0;
        if (value !== undefined)
            reflectionMergePartial<MetalWareItemInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetalWareItemInfo): MetalWareItemInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 ItemId = 2 [json_name = "ItemId"];*/ 2:
                    message.ItemId = reader.uint32();
                    break;
                case /* string Name = 3 [json_name = "Name"];*/ 3:
                    message.Name = reader.string();
                    break;
                case /* string Desc = 4 [json_name = "Desc"];*/ 4:
                    message.Desc = reader.string();
                    break;
                case /* uint32 RateRank3 = 5 [json_name = "RateRank3"];*/ 5:
                    message.RateRank3 = reader.uint32();
                    break;
                case /* uint32 RateRank2 = 6 [json_name = "RateRank2"];*/ 6:
                    message.RateRank2 = reader.uint32();
                    break;
                case /* uint32 RateRank1 = 7 [json_name = "RateRank1"];*/ 7:
                    message.RateRank1 = reader.uint32();
                    break;
                case /* uint32 RateAbility1 = 8 [json_name = "RateAbility1"];*/ 8:
                    message.RateAbility1 = reader.uint32();
                    break;
                case /* uint32 RateAbility2 = 9 [json_name = "RateAbility2"];*/ 9:
                    message.RateAbility2 = reader.uint32();
                    break;
                case /* uint32 RateAbility3 = 10 [json_name = "RateAbility3"];*/ 10:
                    message.RateAbility3 = reader.uint32();
                    break;
                case /* uint32 LimitBreakRateFactor = 11 [json_name = "LimitBreakRateFactor"];*/ 11:
                    message.LimitBreakRateFactor = reader.uint32();
                    break;
                case /* uint32 MinLevelFactor = 12 [json_name = "MinLevelFactor"];*/ 12:
                    message.MinLevelFactor = reader.uint32();
                    break;
                case /* uint32 MaxLevelFactor = 13 [json_name = "MaxLevelFactor"];*/ 13:
                    message.MaxLevelFactor = reader.uint32();
                    break;
                case /* uint32 AbilityLimit = 14 [json_name = "AbilityLimit"];*/ 14:
                    message.AbilityLimit = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetalWareItemInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 ItemId = 2 [json_name = "ItemId"]; */
        if (message.ItemId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.ItemId);
        /* string Name = 3 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Name);
        /* string Desc = 4 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.Desc);
        /* uint32 RateRank3 = 5 [json_name = "RateRank3"]; */
        if (message.RateRank3 !== 0)
            writer.tag(5, WireType.Varint).uint32(message.RateRank3);
        /* uint32 RateRank2 = 6 [json_name = "RateRank2"]; */
        if (message.RateRank2 !== 0)
            writer.tag(6, WireType.Varint).uint32(message.RateRank2);
        /* uint32 RateRank1 = 7 [json_name = "RateRank1"]; */
        if (message.RateRank1 !== 0)
            writer.tag(7, WireType.Varint).uint32(message.RateRank1);
        /* uint32 RateAbility1 = 8 [json_name = "RateAbility1"]; */
        if (message.RateAbility1 !== 0)
            writer.tag(8, WireType.Varint).uint32(message.RateAbility1);
        /* uint32 RateAbility2 = 9 [json_name = "RateAbility2"]; */
        if (message.RateAbility2 !== 0)
            writer.tag(9, WireType.Varint).uint32(message.RateAbility2);
        /* uint32 RateAbility3 = 10 [json_name = "RateAbility3"]; */
        if (message.RateAbility3 !== 0)
            writer.tag(10, WireType.Varint).uint32(message.RateAbility3);
        /* uint32 LimitBreakRateFactor = 11 [json_name = "LimitBreakRateFactor"]; */
        if (message.LimitBreakRateFactor !== 0)
            writer.tag(11, WireType.Varint).uint32(message.LimitBreakRateFactor);
        /* uint32 MinLevelFactor = 12 [json_name = "MinLevelFactor"]; */
        if (message.MinLevelFactor !== 0)
            writer.tag(12, WireType.Varint).uint32(message.MinLevelFactor);
        /* uint32 MaxLevelFactor = 13 [json_name = "MaxLevelFactor"]; */
        if (message.MaxLevelFactor !== 0)
            writer.tag(13, WireType.Varint).uint32(message.MaxLevelFactor);
        /* uint32 AbilityLimit = 14 [json_name = "AbilityLimit"]; */
        if (message.AbilityLimit !== 0)
            writer.tag(14, WireType.Varint).uint32(message.AbilityLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.MetalWareItemInfo
 */
export const MetalWareItemInfo = new MetalWareItemInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetalWareLevelInfo$Type extends MessageType<MetalWareLevelInfo> {
    constructor() {
        super("prilus.MetalWareLevelInfo", [
            { no: 1, name: "Level", kind: "scalar", localName: "Level", jsonName: "Level", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Rank3MinLevel", kind: "scalar", localName: "Rank3MinLevel", jsonName: "Rank3MinLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Rank3MaxLevel", kind: "scalar", localName: "Rank3MaxLevel", jsonName: "Rank3MaxLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "Rank2MinLevel", kind: "scalar", localName: "Rank2MinLevel", jsonName: "Rank2MinLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "Rank2MaxLevel", kind: "scalar", localName: "Rank2MaxLevel", jsonName: "Rank2MaxLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "Rank1MinLevel", kind: "scalar", localName: "Rank1MinLevel", jsonName: "Rank1MinLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "Rank1MaxLevel", kind: "scalar", localName: "Rank1MaxLevel", jsonName: "Rank1MaxLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "LimitBreakMinLevel", kind: "scalar", localName: "LimitBreakMinLevel", jsonName: "LimitBreakMinLevel", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "LimitBreakMaxLevel", kind: "scalar", localName: "LimitBreakMaxLevel", jsonName: "LimitBreakMaxLevel", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<MetalWareLevelInfo>): MetalWareLevelInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Level = 0;
        message.Rank3MinLevel = 0;
        message.Rank3MaxLevel = 0;
        message.Rank2MinLevel = 0;
        message.Rank2MaxLevel = 0;
        message.Rank1MinLevel = 0;
        message.Rank1MaxLevel = 0;
        message.LimitBreakMinLevel = 0;
        message.LimitBreakMaxLevel = 0;
        if (value !== undefined)
            reflectionMergePartial<MetalWareLevelInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetalWareLevelInfo): MetalWareLevelInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Level = 1 [json_name = "Level"];*/ 1:
                    message.Level = reader.uint32();
                    break;
                case /* uint32 Rank3MinLevel = 2 [json_name = "Rank3MinLevel"];*/ 2:
                    message.Rank3MinLevel = reader.uint32();
                    break;
                case /* uint32 Rank3MaxLevel = 3 [json_name = "Rank3MaxLevel"];*/ 3:
                    message.Rank3MaxLevel = reader.uint32();
                    break;
                case /* uint32 Rank2MinLevel = 4 [json_name = "Rank2MinLevel"];*/ 4:
                    message.Rank2MinLevel = reader.uint32();
                    break;
                case /* uint32 Rank2MaxLevel = 5 [json_name = "Rank2MaxLevel"];*/ 5:
                    message.Rank2MaxLevel = reader.uint32();
                    break;
                case /* uint32 Rank1MinLevel = 6 [json_name = "Rank1MinLevel"];*/ 6:
                    message.Rank1MinLevel = reader.uint32();
                    break;
                case /* uint32 Rank1MaxLevel = 7 [json_name = "Rank1MaxLevel"];*/ 7:
                    message.Rank1MaxLevel = reader.uint32();
                    break;
                case /* uint32 LimitBreakMinLevel = 8 [json_name = "LimitBreakMinLevel"];*/ 8:
                    message.LimitBreakMinLevel = reader.uint32();
                    break;
                case /* uint32 LimitBreakMaxLevel = 9 [json_name = "LimitBreakMaxLevel"];*/ 9:
                    message.LimitBreakMaxLevel = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetalWareLevelInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Level = 1 [json_name = "Level"]; */
        if (message.Level !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Level);
        /* uint32 Rank3MinLevel = 2 [json_name = "Rank3MinLevel"]; */
        if (message.Rank3MinLevel !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Rank3MinLevel);
        /* uint32 Rank3MaxLevel = 3 [json_name = "Rank3MaxLevel"]; */
        if (message.Rank3MaxLevel !== 0)
            writer.tag(3, WireType.Varint).uint32(message.Rank3MaxLevel);
        /* uint32 Rank2MinLevel = 4 [json_name = "Rank2MinLevel"]; */
        if (message.Rank2MinLevel !== 0)
            writer.tag(4, WireType.Varint).uint32(message.Rank2MinLevel);
        /* uint32 Rank2MaxLevel = 5 [json_name = "Rank2MaxLevel"]; */
        if (message.Rank2MaxLevel !== 0)
            writer.tag(5, WireType.Varint).uint32(message.Rank2MaxLevel);
        /* uint32 Rank1MinLevel = 6 [json_name = "Rank1MinLevel"]; */
        if (message.Rank1MinLevel !== 0)
            writer.tag(6, WireType.Varint).uint32(message.Rank1MinLevel);
        /* uint32 Rank1MaxLevel = 7 [json_name = "Rank1MaxLevel"]; */
        if (message.Rank1MaxLevel !== 0)
            writer.tag(7, WireType.Varint).uint32(message.Rank1MaxLevel);
        /* uint32 LimitBreakMinLevel = 8 [json_name = "LimitBreakMinLevel"]; */
        if (message.LimitBreakMinLevel !== 0)
            writer.tag(8, WireType.Varint).uint32(message.LimitBreakMinLevel);
        /* uint32 LimitBreakMaxLevel = 9 [json_name = "LimitBreakMaxLevel"]; */
        if (message.LimitBreakMaxLevel !== 0)
            writer.tag(9, WireType.Varint).uint32(message.LimitBreakMaxLevel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.MetalWareLevelInfo
 */
export const MetalWareLevelInfo = new MetalWareLevelInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MiniatureInfo$Type extends MessageType<MiniatureInfo> {
    constructor() {
        super("prilus.MiniatureInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "ItemId", kind: "scalar", localName: "ItemId", jsonName: "ItemId", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "Description", kind: "scalar", localName: "Description", jsonName: "Description", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "BonusStatMap", kind: "map", localName: "BonusStatMap", jsonName: "BonusStatMap", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 13 /*ScalarType.UINT32*/ } },
            { no: 6, name: "IsExtraMiniature", kind: "scalar", localName: "IsExtraMiniature", jsonName: "IsExtraMiniature", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "IsAuctionSearchable", kind: "scalar", localName: "IsAuctionSearchable", jsonName: "IsAuctionSearchable", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<MiniatureInfo>): MiniatureInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.ItemId = 0;
        message.Name = "";
        message.Description = "";
        message.BonusStatMap = {};
        message.IsExtraMiniature = false;
        message.IsAuctionSearchable = false;
        if (value !== undefined)
            reflectionMergePartial<MiniatureInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MiniatureInfo): MiniatureInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 ItemId = 2 [json_name = "ItemId"];*/ 2:
                    message.ItemId = reader.uint32();
                    break;
                case /* string Name = 3 [json_name = "Name"];*/ 3:
                    message.Name = reader.string();
                    break;
                case /* string Description = 4 [json_name = "Description"];*/ 4:
                    message.Description = reader.string();
                    break;
                case /* map<string, uint32> BonusStatMap = 5 [json_name = "BonusStatMap"];*/ 5:
                    this.binaryReadMap5(message.BonusStatMap, reader, options);
                    break;
                case /* bool IsExtraMiniature = 6 [json_name = "IsExtraMiniature"];*/ 6:
                    message.IsExtraMiniature = reader.bool();
                    break;
                case /* bool IsAuctionSearchable = 7 [json_name = "IsAuctionSearchable"];*/ 7:
                    message.IsAuctionSearchable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: MiniatureInfo["BonusStatMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof MiniatureInfo["BonusStatMap"] | undefined, val: MiniatureInfo["BonusStatMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.uint32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field prilus.MiniatureInfo.BonusStatMap");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    internalBinaryWrite(message: MiniatureInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 ItemId = 2 [json_name = "ItemId"]; */
        if (message.ItemId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.ItemId);
        /* string Name = 3 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Name);
        /* string Description = 4 [json_name = "Description"]; */
        if (message.Description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.Description);
        /* map<string, uint32> BonusStatMap = 5 [json_name = "BonusStatMap"]; */
        for (let k of globalThis.Object.keys(message.BonusStatMap))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).uint32(message.BonusStatMap[k]).join();
        /* bool IsExtraMiniature = 6 [json_name = "IsExtraMiniature"]; */
        if (message.IsExtraMiniature !== false)
            writer.tag(6, WireType.Varint).bool(message.IsExtraMiniature);
        /* bool IsAuctionSearchable = 7 [json_name = "IsAuctionSearchable"]; */
        if (message.IsAuctionSearchable !== false)
            writer.tag(7, WireType.Varint).bool(message.IsAuctionSearchable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.MiniatureInfo
 */
export const MiniatureInfo = new MiniatureInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptionSetInfo$Type extends MessageType<OptionSetInfo> {
    constructor() {
        super("prilus.OptionSetInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Name2", kind: "scalar", localName: "Name2", jsonName: "Name2", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "Usage", kind: "scalar", localName: "Usage", jsonName: "Usage", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "Level", kind: "scalar", localName: "Level", jsonName: "Level", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<OptionSetInfo>): OptionSetInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Name2 = "";
        message.Desc = "";
        message.Usage = 0;
        message.Level = 0;
        if (value !== undefined)
            reflectionMergePartial<OptionSetInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OptionSetInfo): OptionSetInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Name2 = 3 [json_name = "Name2"];*/ 3:
                    message.Name2 = reader.string();
                    break;
                case /* string Desc = 4 [json_name = "Desc"];*/ 4:
                    message.Desc = reader.string();
                    break;
                case /* uint32 Usage = 5 [json_name = "Usage"];*/ 5:
                    message.Usage = reader.uint32();
                    break;
                case /* uint32 Level = 6 [json_name = "Level"];*/ 6:
                    message.Level = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OptionSetInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Name2 = 3 [json_name = "Name2"]; */
        if (message.Name2 !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Name2);
        /* string Desc = 4 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.Desc);
        /* uint32 Usage = 5 [json_name = "Usage"]; */
        if (message.Usage !== 0)
            writer.tag(5, WireType.Varint).uint32(message.Usage);
        /* uint32 Level = 6 [json_name = "Level"]; */
        if (message.Level !== 0)
            writer.tag(6, WireType.Varint).uint32(message.Level);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.OptionSetInfo
 */
export const OptionSetInfo = new OptionSetInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PetInfo$Type extends MessageType<PetInfo> {
    constructor() {
        super("prilus.PetInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "LimitTime", kind: "scalar", localName: "LimitTime", jsonName: "LimitTime", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "MinLevelStat", kind: "message", localName: "MinLevelStat", jsonName: "MinLevelStat", T: () => PetStat },
            { no: 4, name: "MaxLevelStat", kind: "message", localName: "MaxLevelStat", jsonName: "MaxLevelStat", T: () => PetStat },
            { no: 5, name: "Skills", kind: "message", localName: "Skills", jsonName: "Skills", repeat: 1 /*RepeatType.PACKED*/, T: () => PetSkill }
        ]);
    }
    create(value?: PartialMessage<PetInfo>): PetInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.LimitTime = 0;
        message.Skills = [];
        if (value !== undefined)
            reflectionMergePartial<PetInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PetInfo): PetInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 LimitTime = 2 [json_name = "LimitTime"];*/ 2:
                    message.LimitTime = reader.uint32();
                    break;
                case /* prilus.PetStat MinLevelStat = 3 [json_name = "MinLevelStat"];*/ 3:
                    message.MinLevelStat = PetStat.internalBinaryRead(reader, reader.uint32(), options, message.MinLevelStat);
                    break;
                case /* prilus.PetStat MaxLevelStat = 4 [json_name = "MaxLevelStat"];*/ 4:
                    message.MaxLevelStat = PetStat.internalBinaryRead(reader, reader.uint32(), options, message.MaxLevelStat);
                    break;
                case /* repeated prilus.PetSkill Skills = 5 [json_name = "Skills"];*/ 5:
                    message.Skills.push(PetSkill.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PetInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 LimitTime = 2 [json_name = "LimitTime"]; */
        if (message.LimitTime !== 0)
            writer.tag(2, WireType.Varint).uint32(message.LimitTime);
        /* prilus.PetStat MinLevelStat = 3 [json_name = "MinLevelStat"]; */
        if (message.MinLevelStat)
            PetStat.internalBinaryWrite(message.MinLevelStat, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* prilus.PetStat MaxLevelStat = 4 [json_name = "MaxLevelStat"]; */
        if (message.MaxLevelStat)
            PetStat.internalBinaryWrite(message.MaxLevelStat, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.PetSkill Skills = 5 [json_name = "Skills"]; */
        for (let i = 0; i < message.Skills.length; i++)
            PetSkill.internalBinaryWrite(message.Skills[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.PetInfo
 */
export const PetInfo = new PetInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PetSkill$Type extends MessageType<PetSkill> {
    constructor() {
        super("prilus.PetSkill", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Level", kind: "scalar", localName: "Level", jsonName: "Level", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "NeedPetLevel", kind: "scalar", localName: "NeedPetLevel", jsonName: "NeedPetLevel", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PetSkill>): PetSkill {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Level = 0;
        message.NeedPetLevel = 0;
        if (value !== undefined)
            reflectionMergePartial<PetSkill>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PetSkill): PetSkill {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 Level = 2 [json_name = "Level"];*/ 2:
                    message.Level = reader.uint32();
                    break;
                case /* uint32 NeedPetLevel = 3 [json_name = "NeedPetLevel"];*/ 3:
                    message.NeedPetLevel = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PetSkill, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 Level = 2 [json_name = "Level"]; */
        if (message.Level !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Level);
        /* uint32 NeedPetLevel = 3 [json_name = "NeedPetLevel"]; */
        if (message.NeedPetLevel !== 0)
            writer.tag(3, WireType.Varint).uint32(message.NeedPetLevel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.PetSkill
 */
export const PetSkill = new PetSkill$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PetStat$Type extends MessageType<PetStat> {
    constructor() {
        super("prilus.PetStat", [
            { no: 1, name: "Str", kind: "scalar", localName: "Str", jsonName: "Str", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Int", kind: "scalar", localName: "Int", jsonName: "Int", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Dex", kind: "scalar", localName: "Dex", jsonName: "Dex", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "Will", kind: "scalar", localName: "Will", jsonName: "Will", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "Luck", kind: "scalar", localName: "Luck", jsonName: "Luck", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "Life", kind: "scalar", localName: "Life", jsonName: "Life", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "Mana", kind: "scalar", localName: "Mana", jsonName: "Mana", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "Stamina", kind: "scalar", localName: "Stamina", jsonName: "Stamina", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PetStat>): PetStat {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Str = 0;
        message.Int = 0;
        message.Dex = 0;
        message.Will = 0;
        message.Luck = 0;
        message.Life = 0;
        message.Mana = 0;
        message.Stamina = 0;
        if (value !== undefined)
            reflectionMergePartial<PetStat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PetStat): PetStat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Str = 1 [json_name = "Str"];*/ 1:
                    message.Str = reader.uint32();
                    break;
                case /* uint32 Int = 2 [json_name = "Int"];*/ 2:
                    message.Int = reader.uint32();
                    break;
                case /* uint32 Dex = 3 [json_name = "Dex"];*/ 3:
                    message.Dex = reader.uint32();
                    break;
                case /* uint32 Will = 4 [json_name = "Will"];*/ 4:
                    message.Will = reader.uint32();
                    break;
                case /* uint32 Luck = 5 [json_name = "Luck"];*/ 5:
                    message.Luck = reader.uint32();
                    break;
                case /* uint32 Life = 6 [json_name = "Life"];*/ 6:
                    message.Life = reader.uint32();
                    break;
                case /* uint32 Mana = 7 [json_name = "Mana"];*/ 7:
                    message.Mana = reader.uint32();
                    break;
                case /* uint32 Stamina = 8 [json_name = "Stamina"];*/ 8:
                    message.Stamina = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PetStat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Str = 1 [json_name = "Str"]; */
        if (message.Str !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Str);
        /* uint32 Int = 2 [json_name = "Int"]; */
        if (message.Int !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Int);
        /* uint32 Dex = 3 [json_name = "Dex"]; */
        if (message.Dex !== 0)
            writer.tag(3, WireType.Varint).uint32(message.Dex);
        /* uint32 Will = 4 [json_name = "Will"]; */
        if (message.Will !== 0)
            writer.tag(4, WireType.Varint).uint32(message.Will);
        /* uint32 Luck = 5 [json_name = "Luck"]; */
        if (message.Luck !== 0)
            writer.tag(5, WireType.Varint).uint32(message.Luck);
        /* uint32 Life = 6 [json_name = "Life"]; */
        if (message.Life !== 0)
            writer.tag(6, WireType.Varint).uint32(message.Life);
        /* uint32 Mana = 7 [json_name = "Mana"]; */
        if (message.Mana !== 0)
            writer.tag(7, WireType.Varint).uint32(message.Mana);
        /* uint32 Stamina = 8 [json_name = "Stamina"]; */
        if (message.Stamina !== 0)
            writer.tag(8, WireType.Varint).uint32(message.Stamina);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.PetStat
 */
export const PetStat = new PetStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductionInfo$Type extends MessageType<ProductionInfo> {
    constructor() {
        super("prilus.ProductionInfo", [
            { no: 1, name: "Type", kind: "scalar", localName: "Type", jsonName: "Type", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "ItemId", kind: "scalar", localName: "ItemId", jsonName: "ItemId", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "FormId", kind: "scalar", localName: "FormId", jsonName: "FormId", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "Level", kind: "scalar", localName: "Level", jsonName: "Level", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "Essentials", kind: "message", localName: "Essentials", jsonName: "Essentials", repeat: 1 /*RepeatType.PACKED*/, T: () => ProductEssential },
            { no: 6, name: "CompleteEssentials", kind: "message", localName: "CompleteEssentials", jsonName: "CompleteEssentials", repeat: 1 /*RepeatType.PACKED*/, T: () => ProductCompleteEssential }
        ]);
    }
    create(value?: PartialMessage<ProductionInfo>): ProductionInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Type = 0;
        message.ItemId = 0;
        message.FormId = 0;
        message.Level = 0;
        message.Essentials = [];
        message.CompleteEssentials = [];
        if (value !== undefined)
            reflectionMergePartial<ProductionInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductionInfo): ProductionInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Type = 1 [json_name = "Type"];*/ 1:
                    message.Type = reader.uint32();
                    break;
                case /* uint32 ItemId = 2 [json_name = "ItemId"];*/ 2:
                    message.ItemId = reader.uint32();
                    break;
                case /* uint32 FormId = 3 [json_name = "FormId"];*/ 3:
                    message.FormId = reader.uint32();
                    break;
                case /* uint32 Level = 4 [json_name = "Level"];*/ 4:
                    message.Level = reader.uint32();
                    break;
                case /* repeated prilus.ProductEssential Essentials = 5 [json_name = "Essentials"];*/ 5:
                    message.Essentials.push(ProductEssential.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.ProductCompleteEssential CompleteEssentials = 6 [json_name = "CompleteEssentials"];*/ 6:
                    message.CompleteEssentials.push(ProductCompleteEssential.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductionInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Type = 1 [json_name = "Type"]; */
        if (message.Type !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Type);
        /* uint32 ItemId = 2 [json_name = "ItemId"]; */
        if (message.ItemId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.ItemId);
        /* uint32 FormId = 3 [json_name = "FormId"]; */
        if (message.FormId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.FormId);
        /* uint32 Level = 4 [json_name = "Level"]; */
        if (message.Level !== 0)
            writer.tag(4, WireType.Varint).uint32(message.Level);
        /* repeated prilus.ProductEssential Essentials = 5 [json_name = "Essentials"]; */
        for (let i = 0; i < message.Essentials.length; i++)
            ProductEssential.internalBinaryWrite(message.Essentials[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.ProductCompleteEssential CompleteEssentials = 6 [json_name = "CompleteEssentials"]; */
        for (let i = 0; i < message.CompleteEssentials.length; i++)
            ProductCompleteEssential.internalBinaryWrite(message.CompleteEssentials[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ProductionInfo
 */
export const ProductionInfo = new ProductionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductEssential$Type extends MessageType<ProductEssential> {
    constructor() {
        super("prilus.ProductEssential", [
            { no: 1, name: "ItemIds", kind: "scalar", localName: "ItemIds", jsonName: "ItemIds", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Count", kind: "scalar", localName: "Count", jsonName: "Count", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<ProductEssential>): ProductEssential {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ItemIds = [];
        message.Count = 0;
        if (value !== undefined)
            reflectionMergePartial<ProductEssential>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductEssential): ProductEssential {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated uint32 ItemIds = 1 [json_name = "ItemIds"];*/ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.ItemIds.push(reader.uint32());
                    else
                        message.ItemIds.push(reader.uint32());
                    break;
                case /* uint32 Count = 2 [json_name = "Count"];*/ 2:
                    message.Count = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductEssential, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated uint32 ItemIds = 1 [json_name = "ItemIds"]; */
        if (message.ItemIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.ItemIds.length; i++)
                writer.uint32(message.ItemIds[i]);
            writer.join();
        }
        /* uint32 Count = 2 [json_name = "Count"]; */
        if (message.Count !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ProductEssential
 */
export const ProductEssential = new ProductEssential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductCompleteEssential$Type extends MessageType<ProductCompleteEssential> {
    constructor() {
        super("prilus.ProductCompleteEssential", [
            { no: 1, name: "Essentials", kind: "message", localName: "Essentials", jsonName: "Essentials", repeat: 1 /*RepeatType.PACKED*/, T: () => ProductEssential },
            { no: 2, name: "ExtraData", kind: "scalar", localName: "ExtraData", jsonName: "ExtraData", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProductCompleteEssential>): ProductCompleteEssential {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Essentials = [];
        message.ExtraData = "";
        if (value !== undefined)
            reflectionMergePartial<ProductCompleteEssential>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductCompleteEssential): ProductCompleteEssential {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated prilus.ProductEssential Essentials = 1 [json_name = "Essentials"];*/ 1:
                    message.Essentials.push(ProductEssential.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string ExtraData = 2 [json_name = "ExtraData"];*/ 2:
                    message.ExtraData = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductCompleteEssential, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated prilus.ProductEssential Essentials = 1 [json_name = "Essentials"]; */
        for (let i = 0; i < message.Essentials.length; i++)
            ProductEssential.internalBinaryWrite(message.Essentials[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string ExtraData = 2 [json_name = "ExtraData"]; */
        if (message.ExtraData !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ExtraData);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.ProductCompleteEssential
 */
export const ProductCompleteEssential = new ProductCompleteEssential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaceInfo$Type extends MessageType<RaceInfo> {
    constructor() {
        super("prilus.RaceInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ClassName", kind: "scalar", localName: "ClassName", jsonName: "ClassName", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "Skills", kind: "message", localName: "Skills", jsonName: "Skills", repeat: 1 /*RepeatType.PACKED*/, T: () => RaceSkill },
            { no: 5, name: "WeakenSkills", kind: "message", localName: "WeakenSkills", jsonName: "WeakenSkills", repeat: 1 /*RepeatType.PACKED*/, T: () => RaceWeakenSkill },
            { no: 6, name: "InventorySizeX", kind: "scalar", localName: "InventorySizeX", jsonName: "InventorySizeX", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "InventorySizeY", kind: "scalar", localName: "InventorySizeY", jsonName: "InventorySizeY", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RaceInfo>): RaceInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.ClassName = "";
        message.Skills = [];
        message.WeakenSkills = [];
        message.InventorySizeX = 0;
        message.InventorySizeY = 0;
        if (value !== undefined)
            reflectionMergePartial<RaceInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaceInfo): RaceInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string ClassName = 3 [json_name = "ClassName"];*/ 3:
                    message.ClassName = reader.string();
                    break;
                case /* repeated prilus.RaceSkill Skills = 4 [json_name = "Skills"];*/ 4:
                    message.Skills.push(RaceSkill.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated prilus.RaceWeakenSkill WeakenSkills = 5 [json_name = "WeakenSkills"];*/ 5:
                    message.WeakenSkills.push(RaceWeakenSkill.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* uint32 InventorySizeX = 6 [json_name = "InventorySizeX"];*/ 6:
                    message.InventorySizeX = reader.uint32();
                    break;
                case /* uint32 InventorySizeY = 7 [json_name = "InventorySizeY"];*/ 7:
                    message.InventorySizeY = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaceInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string ClassName = 3 [json_name = "ClassName"]; */
        if (message.ClassName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ClassName);
        /* repeated prilus.RaceSkill Skills = 4 [json_name = "Skills"]; */
        for (let i = 0; i < message.Skills.length; i++)
            RaceSkill.internalBinaryWrite(message.Skills[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated prilus.RaceWeakenSkill WeakenSkills = 5 [json_name = "WeakenSkills"]; */
        for (let i = 0; i < message.WeakenSkills.length; i++)
            RaceWeakenSkill.internalBinaryWrite(message.WeakenSkills[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* uint32 InventorySizeX = 6 [json_name = "InventorySizeX"]; */
        if (message.InventorySizeX !== 0)
            writer.tag(6, WireType.Varint).uint32(message.InventorySizeX);
        /* uint32 InventorySizeY = 7 [json_name = "InventorySizeY"]; */
        if (message.InventorySizeY !== 0)
            writer.tag(7, WireType.Varint).uint32(message.InventorySizeY);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.RaceInfo
 */
export const RaceInfo = new RaceInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaceSkill$Type extends MessageType<RaceSkill> {
    constructor() {
        super("prilus.RaceSkill", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Level", kind: "scalar", localName: "Level", jsonName: "Level", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RaceSkill>): RaceSkill {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Level = 0;
        if (value !== undefined)
            reflectionMergePartial<RaceSkill>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaceSkill): RaceSkill {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 Level = 2 [json_name = "Level"];*/ 2:
                    message.Level = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaceSkill, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 Level = 2 [json_name = "Level"]; */
        if (message.Level !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Level);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.RaceSkill
 */
export const RaceSkill = new RaceSkill$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaceWeakenSkill$Type extends MessageType<RaceWeakenSkill> {
    constructor() {
        super("prilus.RaceWeakenSkill", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "DmgRate", kind: "scalar", localName: "DmgRate", jsonName: "DmgRate", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RaceWeakenSkill>): RaceWeakenSkill {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.DmgRate = 0;
        if (value !== undefined)
            reflectionMergePartial<RaceWeakenSkill>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaceWeakenSkill): RaceWeakenSkill {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 DmgRate = 2 [json_name = "DmgRate"];*/ 2:
                    message.DmgRate = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaceWeakenSkill, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 DmgRate = 2 [json_name = "DmgRate"]; */
        if (message.DmgRate !== 0)
            writer.tag(2, WireType.Varint).uint32(message.DmgRate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.RaceWeakenSkill
 */
export const RaceWeakenSkill = new RaceWeakenSkill$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RandomTableInfo$Type extends MessageType<RandomTableInfo> {
    constructor() {
        super("prilus.RandomTableInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Elements", kind: "message", localName: "Elements", jsonName: "Elements", repeat: 1 /*RepeatType.PACKED*/, T: () => RandomTableElement },
            { no: 4, name: "TotalProb", kind: "scalar", localName: "TotalProb", jsonName: "TotalProb", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RandomTableInfo>): RandomTableInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Elements = [];
        message.TotalProb = 0;
        if (value !== undefined)
            reflectionMergePartial<RandomTableInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RandomTableInfo): RandomTableInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* repeated prilus.RandomTableElement Elements = 3 [json_name = "Elements"];*/ 3:
                    message.Elements.push(RandomTableElement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* uint32 TotalProb = 4 [json_name = "TotalProb"];*/ 4:
                    message.TotalProb = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RandomTableInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* repeated prilus.RandomTableElement Elements = 3 [json_name = "Elements"]; */
        for (let i = 0; i < message.Elements.length; i++)
            RandomTableElement.internalBinaryWrite(message.Elements[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* uint32 TotalProb = 4 [json_name = "TotalProb"]; */
        if (message.TotalProb !== 0)
            writer.tag(4, WireType.Varint).uint32(message.TotalProb);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.RandomTableInfo
 */
export const RandomTableInfo = new RandomTableInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RandomTableElement$Type extends MessageType<RandomTableElement> {
    constructor() {
        super("prilus.RandomTableElement", [
            { no: 1, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Type", kind: "scalar", localName: "Type", jsonName: "Type", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Min", kind: "scalar", localName: "Min", jsonName: "Min", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "Max", kind: "scalar", localName: "Max", jsonName: "Max", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "Extra", kind: "scalar", localName: "Extra", jsonName: "Extra", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "Prob", kind: "scalar", localName: "Prob", jsonName: "Prob", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RandomTableElement>): RandomTableElement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Name = "";
        message.Type = 0;
        message.Min = 0;
        message.Max = 0;
        message.Extra = 0;
        message.Prob = 0;
        if (value !== undefined)
            reflectionMergePartial<RandomTableElement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RandomTableElement): RandomTableElement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string Name = 1 [json_name = "Name"];*/ 1:
                    message.Name = reader.string();
                    break;
                case /* uint32 Type = 2 [json_name = "Type"];*/ 2:
                    message.Type = reader.uint32();
                    break;
                case /* uint32 Min = 3 [json_name = "Min"];*/ 3:
                    message.Min = reader.uint32();
                    break;
                case /* uint32 Max = 4 [json_name = "Max"];*/ 4:
                    message.Max = reader.uint32();
                    break;
                case /* uint32 Extra = 5 [json_name = "Extra"];*/ 5:
                    message.Extra = reader.uint32();
                    break;
                case /* uint32 Prob = 6 [json_name = "Prob"];*/ 6:
                    message.Prob = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RandomTableElement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string Name = 1 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.Name);
        /* uint32 Type = 2 [json_name = "Type"]; */
        if (message.Type !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Type);
        /* uint32 Min = 3 [json_name = "Min"]; */
        if (message.Min !== 0)
            writer.tag(3, WireType.Varint).uint32(message.Min);
        /* uint32 Max = 4 [json_name = "Max"]; */
        if (message.Max !== 0)
            writer.tag(4, WireType.Varint).uint32(message.Max);
        /* uint32 Extra = 5 [json_name = "Extra"]; */
        if (message.Extra !== 0)
            writer.tag(5, WireType.Varint).uint32(message.Extra);
        /* uint32 Prob = 6 [json_name = "Prob"]; */
        if (message.Prob !== 0)
            writer.tag(6, WireType.Varint).uint32(message.Prob);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.RandomTableElement
 */
export const RandomTableElement = new RandomTableElement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetItemDescElementInfo$Type extends MessageType<SetItemDescElementInfo> {
    constructor() {
        super("prilus.SetItemDescElementInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Key", kind: "scalar", localName: "Key", jsonName: "Key", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SetItemDescElementInfo>): SetItemDescElementInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Key = "";
        message.Name = "";
        message.Desc = "";
        if (value !== undefined)
            reflectionMergePartial<SetItemDescElementInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetItemDescElementInfo): SetItemDescElementInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Key = 2 [json_name = "Key"];*/ 2:
                    message.Key = reader.string();
                    break;
                case /* string Name = 3 [json_name = "Name"];*/ 3:
                    message.Name = reader.string();
                    break;
                case /* string Desc = 4 [json_name = "Desc"];*/ 4:
                    message.Desc = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetItemDescElementInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Key = 2 [json_name = "Key"]; */
        if (message.Key !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Key);
        /* string Name = 3 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Name);
        /* string Desc = 4 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.Desc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.SetItemDescElementInfo
 */
export const SetItemDescElementInfo = new SetItemDescElementInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillInfo$Type extends MessageType<SkillInfo> {
    constructor() {
        super("prilus.SkillInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "Category", kind: "scalar", localName: "Category", jsonName: "Category", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "VariableMap", kind: "map", localName: "VariableMap", jsonName: "VariableMap", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<SkillInfo>): SkillInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Desc = "";
        message.Category = 0;
        message.VariableMap = {};
        if (value !== undefined)
            reflectionMergePartial<SkillInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillInfo): SkillInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Desc = 3 [json_name = "Desc"];*/ 3:
                    message.Desc = reader.string();
                    break;
                case /* uint32 Category = 5 [json_name = "Category"];*/ 5:
                    message.Category = reader.uint32();
                    break;
                case /* map<string, string> VariableMap = 4 [json_name = "VariableMap"];*/ 4:
                    this.binaryReadMap4(message.VariableMap, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: SkillInfo["VariableMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SkillInfo["VariableMap"] | undefined, val: SkillInfo["VariableMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field prilus.SkillInfo.VariableMap");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SkillInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Desc = 3 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Desc);
        /* uint32 Category = 5 [json_name = "Category"]; */
        if (message.Category !== 0)
            writer.tag(5, WireType.Varint).uint32(message.Category);
        /* map<string, string> VariableMap = 4 [json_name = "VariableMap"]; */
        for (let k of globalThis.Object.keys(message.VariableMap))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.VariableMap[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.SkillInfo
 */
export const SkillInfo = new SkillInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SocialMotionInfo$Type extends MessageType<SocialMotionInfo> {
    constructor() {
        super("prilus.SocialMotionInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "AllowRaces", kind: "scalar", localName: "AllowRaces", jsonName: "AllowRaces", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<SocialMotionInfo>): SocialMotionInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.AllowRaces = [];
        if (value !== undefined)
            reflectionMergePartial<SocialMotionInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SocialMotionInfo): SocialMotionInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* repeated uint32 AllowRaces = 3 [json_name = "AllowRaces"];*/ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.AllowRaces.push(reader.uint32());
                    else
                        message.AllowRaces.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SocialMotionInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* repeated uint32 AllowRaces = 3 [json_name = "AllowRaces"]; */
        if (message.AllowRaces.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.AllowRaces.length; i++)
                writer.uint32(message.AllowRaces[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.SocialMotionInfo
 */
export const SocialMotionInfo = new SocialMotionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringInfo$Type extends MessageType<StringInfo> {
    constructor() {
        super("prilus.StringInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Str", kind: "scalar", localName: "Str", jsonName: "Str", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StringInfo>): StringInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = "";
        message.Str = "";
        if (value !== undefined)
            reflectionMergePartial<StringInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StringInfo): StringInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.string();
                    break;
                case /* string Str = 2 [json_name = "Str"];*/ 2:
                    message.Str = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StringInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string Id = 1 [json_name = "Id"]; */
        if (message.Id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.Id);
        /* string Str = 2 [json_name = "Str"]; */
        if (message.Str !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Str);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.StringInfo
 */
export const StringInfo = new StringInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TalentInfo$Type extends MessageType<TalentInfo> {
    constructor() {
        super("prilus.TalentInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "Subject", kind: "scalar", localName: "Subject", jsonName: "Subject", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "Desc", kind: "scalar", localName: "Desc", jsonName: "Desc", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "SkillIds", kind: "scalar", localName: "SkillIds", jsonName: "SkillIds", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<TalentInfo>): TalentInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Name = "";
        message.Subject = "";
        message.Desc = "";
        message.SkillIds = [];
        if (value !== undefined)
            reflectionMergePartial<TalentInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TalentInfo): TalentInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* string Name = 2 [json_name = "Name"];*/ 2:
                    message.Name = reader.string();
                    break;
                case /* string Subject = 3 [json_name = "Subject"];*/ 3:
                    message.Subject = reader.string();
                    break;
                case /* string Desc = 4 [json_name = "Desc"];*/ 4:
                    message.Desc = reader.string();
                    break;
                case /* repeated uint32 SkillIds = 5 [json_name = "SkillIds"];*/ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.SkillIds.push(reader.uint32());
                    else
                        message.SkillIds.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TalentInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* string Name = 2 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.Name);
        /* string Subject = 3 [json_name = "Subject"]; */
        if (message.Subject !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Subject);
        /* string Desc = 4 [json_name = "Desc"]; */
        if (message.Desc !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.Desc);
        /* repeated uint32 SkillIds = 5 [json_name = "SkillIds"]; */
        if (message.SkillIds.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.SkillIds.length; i++)
                writer.uint32(message.SkillIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.TalentInfo
 */
export const TalentInfo = new TalentInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TitleInfo$Type extends MessageType<TitleInfo> {
    constructor() {
        super("prilus.TitleInfo", [
            { no: 1, name: "Id", kind: "scalar", localName: "Id", jsonName: "Id", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "Type", kind: "scalar", localName: "Type", jsonName: "Type", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "Name", kind: "scalar", localName: "Name", jsonName: "Name", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "MaleName", kind: "scalar", localName: "MaleName", jsonName: "MaleName", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "FemaleName", kind: "scalar", localName: "FemaleName", jsonName: "FemaleName", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "UniName", kind: "scalar", localName: "UniName", jsonName: "UniName", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "Effect", kind: "scalar", localName: "Effect", jsonName: "Effect", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "Duration", kind: "scalar", localName: "Duration", jsonName: "Duration", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<TitleInfo>): TitleInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.Id = 0;
        message.Type = 0;
        message.Name = "";
        message.MaleName = "";
        message.FemaleName = "";
        message.UniName = "";
        message.Effect = "";
        message.Duration = 0;
        if (value !== undefined)
            reflectionMergePartial<TitleInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TitleInfo): TitleInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 Id = 1 [json_name = "Id"];*/ 1:
                    message.Id = reader.uint32();
                    break;
                case /* uint32 Type = 2 [json_name = "Type"];*/ 2:
                    message.Type = reader.uint32();
                    break;
                case /* string Name = 3 [json_name = "Name"];*/ 3:
                    message.Name = reader.string();
                    break;
                case /* string MaleName = 4 [json_name = "MaleName"];*/ 4:
                    message.MaleName = reader.string();
                    break;
                case /* string FemaleName = 5 [json_name = "FemaleName"];*/ 5:
                    message.FemaleName = reader.string();
                    break;
                case /* string UniName = 6 [json_name = "UniName"];*/ 6:
                    message.UniName = reader.string();
                    break;
                case /* string Effect = 7 [json_name = "Effect"];*/ 7:
                    message.Effect = reader.string();
                    break;
                case /* uint32 Duration = 8 [json_name = "Duration"];*/ 8:
                    message.Duration = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TitleInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 Id = 1 [json_name = "Id"]; */
        if (message.Id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.Id);
        /* uint32 Type = 2 [json_name = "Type"]; */
        if (message.Type !== 0)
            writer.tag(2, WireType.Varint).uint32(message.Type);
        /* string Name = 3 [json_name = "Name"]; */
        if (message.Name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.Name);
        /* string MaleName = 4 [json_name = "MaleName"]; */
        if (message.MaleName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.MaleName);
        /* string FemaleName = 5 [json_name = "FemaleName"]; */
        if (message.FemaleName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.FemaleName);
        /* string UniName = 6 [json_name = "UniName"]; */
        if (message.UniName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.UniName);
        /* string Effect = 7 [json_name = "Effect"]; */
        if (message.Effect !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.Effect);
        /* uint32 Duration = 8 [json_name = "Duration"]; */
        if (message.Duration !== 0)
            writer.tag(8, WireType.Varint).uint32(message.Duration);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message prilus.TitleInfo
 */
export const TitleInfo = new TitleInfo$Type();
